/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-self-assign */
/* eslint-disable no-loop-func */
/* eslint-disable import/no-cycle */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-inner-declarations */
import React, { useState, useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
// import axios from 'axios';
import CryptoJS from 'crypto-js';
// import AWS from 'aws-sdk';
// import { URL } from 'url';
import { get, includes, lowerCase } from 'lodash';
import { ExecuteContext } from '../Flow';
import { isProductAvailableInRegion, isProductAvailableInRegionforAccessUsers, getRegionAccess } from '../../shared/Products';
import { setStream_ouput_data } from '../../app/features/dataSlices';
import { convertUnitValues_pressure } from '../../shared/conversion-helper/unitConversion';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { executeError, executeNoError, modifiedDate, sortingRoData, executeArgoDefault } from '../../shared/constantVariable';
import { isObjectEmpty, getErrorHelperData, updateControlsButtonTitle, cleanMessage } from '../../shared/helper';
import { deleteWinAndProjectFile, postWinflowsSolveOrder, checkFileExists } from '../../shared/api/url-helper';
// import DownloadFlowsheet from '../DownloadFlowsheet';
import { decrypt_data } from '../../shared/utils';
import findAllPath from './FindAllPath';
import { checkUnitType, get_language_selection } from '../userData';

const ExecutePopup = (props) => {
  const {
    openModelPopUp,
    element,
    edges,
    findAllConnection,
    connectionInfo_source_target,
    fetchLoadings,
    disabledStripperAndExplorerTab,
    executeObjs,
    reportErrorListDatas,
    wexpex_all_unitop,
    peltonwheel_all_unitop,
    turbocharger_all_unitop,
    custom_all_ROHPLoop,
    custom_all_ROLoop,
    filename,
    setInputOutputFlag,
    ediOutputDataset,
    translateObject,
    dbTransactionDetails,
    setUseRefAfterExecute,
    setEnableMixSplitRo
    // clro_all_unitop
  } = props;
  const executeEdiData = useContext(ExecuteContext);
  let { executeOptionFlag, duplicateNodeFlag } = props;
  const [executeFlag, setExecuteFlag] = useState(true);

  function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }
  function hasUserRegionKey(argoDict) {
    return Object.prototype.hasOwnProperty.call(argoDict || {}, 'user_region');
  }
  const dispatch = useDispatch();

  const checkRoExitsOrNot = (obj) => {
    const arr = [...checkUnitType];
    const f = Object.values(obj).filter((ele) => {
      return arr.indexOf(ele.unit_type) >= 0;
    });
    if (f.length > 0) {
      return false;
    }
    return true;
  };
  const isFirstPump = (pumpId) => pumpId === 'roPump_1' || pumpId === 'nfPump_1' || pumpId === 'roHPPumpRoHPLoop_1' || pumpId === 'roPumpRoLoop_1';
  const decideRoType = (pumpId) => {
    const flow_sheet_dict_path = JSON.parse(localStorage.getItem('flow_sheet_dict') || 'null');
    const toRo = edges.find(e => e.target === pumpId);
    const roHandle = toRo?.sourceHandle ?? null;

    const idx = pumpId?.split('_')?.[1];
    const hpId = `hppump_${idx}`;

    const toHp = edges.find(e => e.target === hpId);
    const hpHandle = toHp?.sourceHandle ?? null;

    const hpSource = toHp?.source;
    const toHpSource = hpSource ? edges.find(e => e.target === hpSource) : null;
    const erdHandle = toHpSource?.sourceHandle ?? null;

    if (roHandle === 'd' || hpHandle === 'd' || erdHandle === 'd') return 'brine';

    if (flow_sheet_dict_path && flow_sheet_dict_path.Type !== '1 Pass' && !isFirstPump(pumpId)) return 'pass';

    if (!isFirstPump(pumpId) && (roHandle === 'c' || hpHandle === 'c')) return 'pass';

    return ''; // <-- IMPORTANT: default empty string
  };
  const onExecute = async () => {
    // Version 11 changes are added
    let elements = [];
    elements = [...element, ...edges];
    if (!executeOptionFlag) {
      openModelPopUp(translateObject('Flowsheet is either empty or incomplete...'), 'Warning', 'warning');
      return;
    }
    // const dataValues = [];
    const unitOpName = {};
    const unitOpType = {};
    // const unitOpDetails = [];
    const outgoing_connection = [];
    const incoming_connection = [];
    const unitOpID = [];
    // const unitOpDetails_final = [];
    const stream_input_dict = {};
    // const stream_details_forpump = {};
    const unit_op_dict = {};
    const unitop_dict = {};
    const unitOpDetails_FeedStream = {};
    const unitOpDetails_ROWasteStream = {};
    const unitOpDetails_WasteStream = {};
    const unitOpDetails_SplitStream = {};
    const unitOpDetails_ProductStream = {};
    const unitOpDetails_ElectrodeStream = {};
    const unitOpDetails_ConcStream = {};
    const unitOpDetails_Recirc = {};
    const unit_set_dict = {};
    // const ro_set_dict = {};
    const unitOp_color = [];
    let Mix_Split1_Feed_val = [];
    let Mix_Split1_HP_val = [];
    let Mix_Split1_ERD_val = [];
    let Mix_Split2_HP_val = [];
    let Mix_Split2_Booster_val = [];
    let ERD_Waste_val = [];
    let ERD_Booster_val = [];
    const unitSet_dict = JSON.parse(localStorage.getItem('system-units')) || {};
    const feed_dict = JSON.parse(localStorage.getItem('feed-dict')) || {};
    const dosing_dict = JSON.parse(localStorage.getItem('dosing-dict')) || {};
    const edi_dict = JSON.parse(localStorage.getItem('edi-dict')) || {};
    const cf_dict = JSON.parse(localStorage.getItem('cf-dict')) || {};
    const pump_dict = JSON.parse(localStorage.getItem('pump-dict')) || {};
    const recirc_dict = JSON.parse(localStorage.getItem('recirc-dict')) || {};
    const recircRo_dict = JSON.parse(localStorage.getItem('recircRo-dict')) || {};
    const hp_pump_dict = JSON.parse(localStorage.getItem('hp-pump-dict')) || {};
    const mixSplit_dict = get(JSON.parse(localStorage.getItem('mixSplit-dict')), 'mixSplit', {});
    let ro_dict = get(JSON.parse(localStorage.getItem('ro-dict')), 'ro', {}); // JSON.parse(localStorage.getItem('ro-dict')) || {};
    const clro_dict = get(JSON.parse(localStorage.getItem('clro-dict')), 'ro', {}); // JSON.parse(localStorage.getItem('ro-dict')) || {};
    const ro_payload = JSON.parse(localStorage.getItem('ro_payload')) || {};
    const roHPLoopStage = JSON.parse(localStorage.getItem('roHPLoop-stage-data')) || {};
    const clro_payload = JSON.parse(localStorage.getItem('clro_payload')) || {};
    const work_exc = JSON.parse(localStorage.getItem('work_exc-dict')) || {};
    const pelton_exc = JSON.parse(localStorage.getItem('pelton_wheel-dict')) || {};
    const turbo_exc = JSON.parse(localStorage.getItem('turbo_charger-dict')) || {};
    const stripper_dict = JSON.parse(localStorage.getItem('stripper-dict')) || {};
    const project_info_set_dict = JSON.parse(localStorage.getItem('project_info')) || {};
    const flow_dict = JSON.parse(localStorage.getItem('flow_dict')) || {};
    const StandAloneArgo = String(localStorage.getItem('StandAloneARGO')).toLowerCase() === 'true';
    let feedValCheck = false;
    // let otherValCheck = true;
    if (Object.keys(ro_payload).length > 0) {
      Object.keys(ro_payload.ro).forEach((pumpId) => {
        // ensure object exists
        ro_payload.ro[pumpId] = ro_payload.ro[pumpId] || {};
        ro_payload.ro[pumpId].ro_type = decideRoType(pumpId);
      });
    }
    localStorage.setItem('ro_payload', JSON.stringify(ro_payload));
    if (Object.keys(flow_dict).length === 0) {
      feedValCheck = true;
    } else if (flow_dict && flow_dict.feed_flow_flag) {
      Object.keys(flow_dict).forEach((key) => {
        if (!key.includes('feed_flow_flag')) {
          if (key.includes('Feed') && Number(flow_dict[key]) >= 0) {
            if (Number(flow_dict[key]) === 0) {
              feedValCheck = true;
            }
          }
        }
      });
    } else {
      feedValCheck = true;
      Object.keys(flow_dict).forEach((key) => {
        if (!key.includes('feed_flow_flag')) {
          if (!key.includes('Feed') && Number(flow_dict[key]) > 0) {
            feedValCheck = false;
          }
        }
      });
    }
    if (!findAllConnection && !StandAloneArgo) {
      if (feedValCheck) {
        localStorage.setItem('streamDataHighlited', 'less');
        openModelPopUp('Please add/update specify flow values!', 'Warning', 'warning');
        return false;
      }
    }
    if (localStorage.getItem('previous_flow_unit')) {
      localStorage.removeItem('previous_flow_unit');
    }
    if (localStorage.getItem('current-unit-work')) {
      localStorage.removeItem('current-unit-work');
    }
    if (localStorage.getItem('cf-output-dict')) {
      localStorage.removeItem('cf-output-dict');
    }
    // const ro_dict = JSON.parse(localStorage.getItem('ro-dict')) || {};
    // const ro_dict  = JSON.parse(localStorage.getItem('ro_payload')) || {};
    // const final_table_dict_1 =
    // {
    //   dbTransactionDetails
    // };
    // const final_table_dict = final_table_dict_1.dbTransactionDetails;
    const languageObj = { en: 'English', 'en-US': 'English', zh: 'Chinese', es: 'Spanish', fr: 'French', de: 'German' };
    if (unitSet_dict.flow) {
      unit_set_dict['Volume Flow'] = unitSet_dict.flow;
      unit_set_dict.Pressure = unitSet_dict.pressure;
      unit_set_dict.Temperature = unitSet_dict.temp;
      unit_set_dict['Liquid Volume'] = unitSet_dict.volume;
      unit_set_dict.Flux = unitSet_dict.flux;
      unit_set_dict.Power = unitSet_dict.power;
    } else {
      unit_set_dict['Volume Flow'] = 'gpm';
      unit_set_dict.Pressure = 'atm';
      unit_set_dict.Temperature = '°C';
      unit_set_dict['Liquid Volume'] = 'gal';
      unit_set_dict.Flux = 'gfd';
      unit_set_dict.Power = 'kW';
    }
    unit_set_dict.language = languageObj[get_language_selection()];
    for (let i = 0; i < elements.length; i += 1) {
      if (elements[i].source && elements[i].data.streamNum_dict) {
        // if (elements[i].data.streamNum_dict) {
        if (elements[i].data.streamNum_dict[elements[i].data.text])
          elements[i].data.text = elements[i].data.streamNum_dict[elements[i].data.text];
        // }

      }
    }

    // to make the sorted elements
    const elements_sorted = [];
    let ediOutputData = [];
    for (let i = 0; i < elements.length; i += 1) {
      if (elements[i].id && elements[i].id.length < 19) {
        elements_sorted.push(elements[i]);
      }
    }
    for (let i = 0; i < elements.length; i += 1) {
      if (elements[i].source) {
        elements_sorted.push(elements[i]);
      }
    }
    // GB-2259 chandrashekhar kumar added.
    ediOutputData = elements_sorted.filter((ele) => {
      // get the all edi unitop whose type of customnode_edi.
      return ele.type === 'customnode_edi';
    });
    if (ediOutputData.length && ediOutputData[0].id) {
      const data = [];
      for (let k = 0; k < ediOutputData.length; k += 1) {
        data.push(elements_sorted.filter((ele) => {
          // get the all edi unitop whose source handle is 'c' (outgoing) and source and id is same.
          return ele.source === ediOutputData[k].id && ele.sourceHandle === 'c';
        }));
      }
      ediOutputData = data.flat(Infinity);
    }
    // GB-2259 chandrashekhar kumar added.
    // end
    const EDIConnection = {};
    const EDIFormData = {};
    for (let i = 0; i < elements_sorted.length; i += 1) {
      if (elements_sorted[i].id && elements_sorted[i].id.length < 19) {
        unitOpName[elements_sorted[i].id] = localStorage.getItem(elements_sorted[i].id);
        unitOpID.push(elements_sorted[i].id);
        if (!findAllConnection) {
          // @sudarsana here chandrashaker added new logic for className.indexOf('disabled') === -1 this is for fixing wex/pex issue mixsplit
          if (document.querySelector(`.Node_${elements_sorted[i].id}`) && document.querySelector(`.Node_${elements_sorted[i].id}`).closest('.react-flow__node').style.borderColor === '' && document.querySelector(`.Node_${elements_sorted[i].id}`).closest('.react-flow__node').className.indexOf('disabled') === -1 && !elements_sorted[i].id.includes('product_') && !elements_sorted[i].id.includes('wasteout_') && !elements_sorted[i].id.includes('boosterpump_')) {
            unitOp_color.push(unitOpName[elements_sorted[i].id]);
          }
        }
        const elementsSortedName = (elements_sorted[i].id).replace(/[\d_]+/g, '');
        if (elementsSortedName === 'stripper')
          unitOpType[elements_sorted[i].id] = 'Stripper';
        if (elementsSortedName === 'product')
          unitOpType[elements_sorted[i].id] = 'ProductOut';
        if (elementsSortedName === 'feed')
          unitOpType[elements_sorted[i].id] = 'Feed';
        if (elementsSortedName === 'ro')
          unitOpType[elements_sorted[i].id] = 'RO';
        if (elementsSortedName === 'nf')
          unitOpType[elements_sorted[i].id] = 'NF';
        if (elementsSortedName === 'nfPump') {
          unitOpType[elements_sorted[i].id] = 'NF_HP';
        }
        if (elementsSortedName === 'roHPPumpRoHPLoop') {
          unitOpType[elements_sorted[i].id] = 'ROHP_FeedBleed';
        }
        if (elementsSortedName === 'ropumpRoLoop') {
          unitOpType[elements_sorted[i].id] = 'RO_FeedBleed';
        }
        if (elementsSortedName === 'RecircROHP') {
          unitOpType[elements_sorted[i].id] = 'HP_Pump';
        }
        if (elementsSortedName === 'RecircRO') {
          unitOpType[elements_sorted[i].id] = 'HP_Pump';
        }
        if (elementsSortedName === 'roPump') {
          if (elements_sorted[i].type === 'customnode_CLROpump') {
            unitOpType[elements_sorted[i].id] = 'CLRO';
          }
          else {
            unitOpType[elements_sorted[i].id] = 'RO_HP';
          }
        }
        if (elementsSortedName === 'hppump')
          unitOpType[elements_sorted[i].id] = 'HP_Pump';
        if (elementsSortedName === 'edi')
          unitOpType[elements_sorted[i].id] = 'EDI';
        if ((elements[i].id).replace(/[\d_]+/g, '') === 'pump')
          unitOpType[elements_sorted[i].id] = 'Pump';
        if (elementsSortedName === 'mixsplit')
          unitOpType[elements_sorted[i].id] = 'Mixer_Splitter';
        if (elementsSortedName === 'wasteout')
          unitOpType[elements_sorted[i].id] = 'Waste';
        if (elementsSortedName === 'cartridge')
          unitOpType[elements_sorted[i].id] = 'Cartridge';
        if (elementsSortedName === 'chemicaldosing')
          unitOpType[elements_sorted[i].id] = 'Chemical_Dosing';
        if (elementsSortedName === 'wex')
          unitOpType[elements_sorted[i].id] = 'ERD';
        if (elementsSortedName === 'peltonwheel')
          unitOpType[elements_sorted[i].id] = 'PW';
        if (elementsSortedName === 'TC')
          unitOpType[elements_sorted[i].id] = 'TC';
        if (elementsSortedName === 'WaterComp')
          unitOpType[elements_sorted[i].id] = 'WaterComp';
        if (elementsSortedName === 'Argo')
          unitOpType[elements_sorted[i].id] = 'Argo';
      }
      if (elements_sorted[i].source && unitOpName[elements_sorted[i].source] && elements_sorted[i].target !== 'undefined') {
        stream_input_dict[elements_sorted[i].data.text] = { 'source': unitOpName[elements_sorted[i].source], 'destination': unitOpName[elements_sorted[i].target] };
        if (elements_sorted[i] && elements_sorted[i].target && elements_sorted[i].target.toUpperCase().indexOf('EDI') >= 0) {
          EDIConnection[elements_sorted[i].data.text] = unitOpName[elements_sorted[i].target];
        }
      }
    }

    // ###### for unitop duplication #########
    let unitop_duplicates = '';
    let tempVal = [];
    Object.keys(unitOpName).forEach((item) => {
      tempVal.push(unitOpName[item]);
    });
    tempVal = tempVal.filter((element) => {
      return element != null;
    });

    tempVal.filter((currentValue, currentIndex) => {
      if (tempVal.indexOf(currentValue) !== currentIndex) {
        unitop_duplicates += currentValue;
      }
    });
    if (!findAllConnection) {
      if (unitop_duplicates.length > 0) {
        document.body.classList.add('duplicate');
        duplicateNodeFlag = true;
        openModelPopUp(
          `Duplicates are not allowed for unitoperation names. <br />
        Please change the names of following unit operations <br />
        [${unitop_duplicates}]`, 'Warning', 'warning'
        );
        return;
      }
    }
    // ###### End ###########

    // for Stream Number duplicate Start
    const nodeVal = [];
    let stream_number_duplicates = [];
    document.querySelectorAll('.react-flow__edges input').forEach((ele) => {
      nodeVal.push(ele.value);
    });
    stream_number_duplicates = nodeVal.filter((val, ind) => {
      if (nodeVal.indexOf(val) !== ind) {
        return val;
      }
    });
    if (!findAllConnection) {
      if (stream_number_duplicates.length > 0) {
        document.body.classList.add('duplicate');
        duplicateNodeFlag = true;
        openModelPopUp(
          `Duplicates are not allowed for Stream numbers. <br />
        Please update the following stream numbers. <br />
        [${stream_number_duplicates.join(',')}]`, 'Warning', 'warning'
        );
        return;
      }
    }
    // Stream Number Duplicate End

    let unitOp_color_string = '';
    unitOp_color.forEach(element => {
      unitOp_color_string += `${element}, `;
    });
    if (!findAllConnection) {
      if (unitOp_color.length > 0) {
        document.body.classList.add('duplicate');
        openModelPopUp(`${unitOp_color_string} ${translateObject('Unitop inputs are either incomplete or incorrect!')}`, 'Warning', 'warning');
        return;
      }
    }
    const stream_input_dict_final = {
      stream_input_dict
    };

    // Added by Akhil on 23rd Jan25 -> function to check duplicates in array when dictionaries are there
    /**
     * This function finds duplicate values in an array of objects based on a specified key.
     * It returns an array of values that occur more than once for the given key.
     *
     * @param {Array} arr - The array of objects to search for duplicates.
     * @param {string} key - The key to check for duplicate values.
     * @returns {Array} - An array of duplicate values.
     */
    // function to check duplicates in array when dictionaries are there
    function findDuplicatesByKey(arr, key) {
      // Count occurrences of each value
      const counts = arr.reduce((acc, obj) => {
        acc[obj[key]] = (acc[obj[key]] || 0) + 1;
        return acc;
      }, {});

      // Filter for values that occur more than once
      const duplicates = Object.entries(counts)
        .filter(([, count]) => count > 1)
        .map(([value]) => value);

      return duplicates;
    }

    for (let i = 0; i < unitOpID.length; i += 1) {
      for (let j = 0; j < elements.length; j += 1) {
        // if element is source
        if (unitOpID[i] === elements[j].source) {
          outgoing_connection.push({ 'UnitOp': unitOpID[i], 'Outgoing': elements[j].target, 'stream': elements[j].data.text, 'port': elements[j].sourceHandle });
          // added this code by Akhil to remove duplicate dict from an Array.. ref: 3pass_not_saved.win
          const outgoing_unitop = findDuplicatesByKey(outgoing_connection, 'Outgoing');
          const unitop = findDuplicatesByKey(outgoing_connection, 'UnitOp');
          const streamNo = findDuplicatesByKey(outgoing_connection, 'stream');

          if (outgoing_unitop.length > 0 && unitop.length > 0 && streamNo.length > 0 && outgoing_unitop[0] === elements[j].target && unitop[0] === unitOpID[i] && streamNo[0] === (elements[j].data.text).toString()) {
            outgoing_connection.pop();
          }
        }

        // if element is target
        if (unitOpID[i] === elements[j].target) {
          incoming_connection.push({ 'UnitOp': unitOpID[i], 'Incoming': elements[j].source, 'stream': elements[j].data.text, 'port': elements[j].targetHandle });

          const incoming_unitop = findDuplicatesByKey(incoming_connection, 'Incoming');
          const unitop = findDuplicatesByKey(incoming_connection, 'UnitOp');
          const streamNo = findDuplicatesByKey(incoming_connection, 'stream');

          if (incoming_unitop.length > 0 && unitop.length > 0 && streamNo.length > 0 && incoming_unitop[0] === elements[j].source && unitop[0] === unitOpID[i] && streamNo[0] === (elements[j].data.text).toString()) {
            incoming_connection.pop();
          }

        }
      }
    }
    // ############## testing phase ##############
    for (let j = 0; j < incoming_connection.length; j += 1) {
      if (unitOpID.indexOf(incoming_connection[j].UnitOp) !== -1) {
        // unitOpDetails_FeedStream.push({ 'Unit Type': incoming_connection[j]['UnitOp'], 'Feed Stream': [incoming_connection[j]['stream']] })
        if (!incoming_connection[j].UnitOp.includes('TC') && !incoming_connection[j].UnitOp.includes('wex') && incoming_connection[j].UnitOp in unitOpDetails_FeedStream) {
          unitOpDetails_FeedStream[incoming_connection[j].UnitOp].push(incoming_connection[j].stream);
          unitOpDetails_FeedStream[incoming_connection[j].UnitOp] = unitOpDetails_FeedStream[incoming_connection[j].UnitOp];
        }
        else if (incoming_connection[j].UnitOp.includes('wex')) {
          if (incoming_connection[j].port === 'a_w') {
            // unitOpDetails_FeedStream[incoming_connection[j].UnitOp].push(incoming_connection[j].stream);
            unitOpDetails_FeedStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream]; // unitOpDetails_FeedStream[incoming_connection[j].UnitOp];
          }
          else {
            unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream];
          }

          // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp].push(incoming_connection[j].stream);
          // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream]; // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp];
        }
        else if (incoming_connection[j].UnitOp.includes('TC')) {
          if (incoming_connection[j].port === 'a_tc') {
            // unitOpDetails_FeedStream[incoming_connection[j].UnitOp].push(incoming_connection[j].stream);
            unitOpDetails_FeedStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream]; // unitOpDetails_FeedStream[incoming_connection[j].UnitOp];
          }
          else {
            unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream];
          }
          // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp].push(incoming_connection[j].stream);
          // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream]; // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp];
        }
        else {
          unitOpDetails_FeedStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream];
        }
      }
    }
    for (let j = 0; j < outgoing_connection.length; j += 1) {
      if (unitOpID.indexOf(outgoing_connection[j].UnitOp) !== -1) {
        // unitOpDetails_WasteStream.push({ 'Unit Type': outgoing_connection[j]['UnitOp'], 'Waste Stream': [outgoing_connection[j]['stream']] })
        if (outgoing_connection[j].port === 'd' || outgoing_connection[j].port === 'd_w' || outgoing_connection[j].port === 'd_tc') {
          unitOpDetails_WasteStream[outgoing_connection[j].UnitOp] = [outgoing_connection[j].stream];
        }
        if (outgoing_connection[j].port === 'e') {
          // unitOpDetails_WasteStream.push({ 'Unit Type': outgoing_connection[j]['UnitOp'], 'Waste Stream': [outgoing_connection[j]['stream']] })
          unitOpDetails_ElectrodeStream[outgoing_connection[j].UnitOp] = [outgoing_connection[j].stream];
        }
        if (outgoing_connection[j].port === 'f') {
          // unitOpDetails_WasteStream.push({ 'Unit Type': outgoing_connection[j]['UnitOp'], 'Waste Stream': [outgoing_connection[j]['stream']] })
          unitOpDetails_ConcStream[outgoing_connection[j].UnitOp] = [outgoing_connection[j].stream];
        }
        if (outgoing_connection[j].port === 's') {
          // unitOpDetails_WasteStream.push({ 'Unit Type': outgoing_connection[j]['UnitOp'], 'Waste Stream': [outgoing_connection[j]['stream']] })
          unitOpDetails_SplitStream[outgoing_connection[j].UnitOp] = [outgoing_connection[j].stream];
        }
        if (outgoing_connection[j].port === 'c' || outgoing_connection[j].port === 'b_w' || outgoing_connection[j].port === 'b_tc') {
          // unitOpDetails_ProductStream.push({ 'Unit Type': outgoing_connection[j]['UnitOp'], 'Product Stream': [outgoing_connection[j]['stream']] })
          if (outgoing_connection[j].UnitOp in unitOpDetails_ProductStream) {
            // a.push(outgoing_connection[j].stream);
            unitOpDetails_ProductStream[outgoing_connection[j].UnitOp].push(outgoing_connection[j].stream);
            unitOpDetails_ProductStream[outgoing_connection[j].UnitOp] = unitOpDetails_ProductStream[outgoing_connection[j].UnitOp];
          } else {
            unitOpDetails_ProductStream[outgoing_connection[j].UnitOp] = [outgoing_connection[j].stream];
          }
        }
      }
    }
    for (let i = 0; i < unitOpID.length; i += 1) {

      let unitType;
      const unitopIdName = unitOpID[i].replace(/[\d_]+/g, '');
      if (unitopIdName === 'product') {
        unitType = 'ProductOut';
      }
      if (unitopIdName === 'stripper') {
        unitType = 'Stripper';
      } else if (unitopIdName === 'ro') {
        unitType = 'RO';
      } else if (unitopIdName === 'nf') {
        unitType = 'RO';
      } else if (unitopIdName === 'nfPump') {
        unitType = 'RO_HP';
      } else if (unitopIdName === 'roHPPumpRoHPLoop') {
        unitType = 'ROHP_FeedBleed';
      }
      else if (unitopIdName === 'ropumpRoLoop') {
        unitType = 'RO_FeedBleed';
      }
      else if (unitopIdName === 'RecircROHP') {
        unitType = 'HP_Pump';
      }
      else if (unitopIdName === 'RecircRO') {
        unitType = 'HP_Pump';
      }
      else if (unitopIdName === 'feed') {
        unitType = 'Feed';
      } else if (unitopIdName === 'chemicaldosing') {
        unitType = 'Chemical_Dosing';
      } else if (unitopIdName === 'edi') {
        unitType = 'EDI';
      } else if (unitopIdName === 'hppump') {
        unitType = 'HP_Pump';
      } else if (unitopIdName === 'pump') {
        unitType = 'Pump';
      } else if (unitopIdName === 'roPump') {
        elements_sorted.forEach((item) => {
          if (unitOpID[i] === item.id) {
            if (item.type === 'customnode_CLROpump') {
              unitType = 'CLRO';
            } else {
              unitType = 'RO_HP';
            }
          }
        });
      } else if (unitopIdName === 'mixsplit') {
        unitType = 'Mixer_Splitter';
      } else if (unitopIdName === 'wasteout') {
        unitType = 'WasteOut';
      } else if (unitopIdName === 'cartridge') {
        unitType = 'CF';
      } else if (unitopIdName === 'wex') {
        unitType = 'ERD';
      } else if (unitopIdName === 'peltonwheel') {
        unitType = 'PW';
      } else if (unitopIdName === 'TC') {
        unitType = 'TC';
      } else if (unitopIdName === 'clro') {
        unitType = 'CLRO';
      } else if (unitopIdName === 'boosterpump') {
        unitType = 'BoosterPump';
      }
      else if (unitopIdName === 'Wateranalysis') {
        unitType = 'WaterComp';
      } else if (unitopIdName === 'Argo') {
        unitType = 'Argo';
      }
      if (unitOpDetails_FeedStream[unitOpID[i]] === undefined)
        unitOpDetails_FeedStream[unitOpID[i]] = [];
      if (unitOpDetails_ROWasteStream[unitOpID[i]] === undefined)
        unitOpDetails_ROWasteStream[unitOpID[i]] = [];
      if (unitOpDetails_WasteStream[unitOpID[i]] === undefined)
        unitOpDetails_WasteStream[unitOpID[i]] = [];
      if (unitOpDetails_SplitStream[unitOpID[i]] === undefined)
        unitOpDetails_SplitStream[unitOpID[i]] = [];
      if (unitOpDetails_ElectrodeStream[unitOpID[i]] === undefined)
        unitOpDetails_ElectrodeStream[unitOpID[i]] = [];
      if (unitOpDetails_ConcStream[unitOpID[i]] === undefined)
        unitOpDetails_ConcStream[unitOpID[i]] = [];
      if (unitOpDetails_ProductStream[unitOpID[i]] === undefined)
        unitOpDetails_ProductStream[unitOpID[i]] = [];

      if (unitType === 'EDI') {
        unit_op_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Electrode_Bleed': unitOpDetails_ElectrodeStream[unitOpID[i]],
          'Conc_Bleed': unitOpDetails_ConcStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
        unitop_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Electrode_Bleed': unitOpDetails_ElectrodeStream[unitOpID[i]],
          'Conc_Bleed': unitOpDetails_ConcStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
      } else if (unitType === 'RO' || unitType === 'RO_HP' || unitType === 'CLRO' || unitType === 'NF' || unitType === 'NF_HP') {
        unit_op_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Split_flow': unitOpDetails_SplitStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
        unitop_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Split_flow': unitOpDetails_SplitStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
      } else if (unitType === 'ERD' || unitType === 'TC') {
        unit_op_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'RO_Waste': unitOpDetails_ROWasteStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
        unitop_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'RO_Waste': unitOpDetails_ROWasteStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
      } else if (unitType === 'HP_Pump') {
        unit_op_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
        unitop_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
      }
      else if (unitType === 'ROHP_FeedBleed') {
        unit_op_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Split_flow': unitOpDetails_SplitStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
        unitop_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Split_flow': unitOpDetails_SplitStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
      }
      else if (unitType === 'RO_FeedBleed') {
        unit_op_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Split_flow': unitOpDetails_SplitStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
        unitop_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Split_flow': unitOpDetails_SplitStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
      }
      else {
        unit_op_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
        unitop_dict[unitOpName[unitOpID[i]]] = {
          'Unit Type': unitType,
          'Feed': unitOpDetails_FeedStream[unitOpID[i]],
          'Waste': unitOpDetails_WasteStream[unitOpID[i]],
          'Product': unitOpDetails_ProductStream[unitOpID[i]],
          'name': unitOpName[unitOpID[i]]
        };
      }
      if (isObjectEmpty(feed_dict) && includes(lowerCase(unitOpID[i]), 'feed')) {

        // By Abhishek on 11-7-25 : GB-3001 : when Ca++ & Mg++ present then Hardnes can't be zero
        const ppm_dict = get(feed_dict, `feed.${unitOpID[i]}.ion_ppm_dict`, '');
        const hadns = get(feed_dict, `feed.${unitOpID[i]}.hardness`, '');

        let feed_hardness = 0;
        if (hadns === 0 && ppm_dict['Ca++'] > 0 || ppm_dict['Mg++'] > 0) {
          feed_hardness = (ppm_dict['Ca++'] * 2.51) + (ppm_dict['Mg++'] * 4.11);
        }
        else {
          feed_hardness = get(feed_dict, `feed.${unitOpID[i]}.hardness`, '');
        }

        unitop_dict[unitOpName[unitOpID[i]]].ion_ppm_dict = get(feed_dict, `feed.${unitOpID[i]}.ion_ppm_dict`, '');
        unitop_dict[unitOpName[unitOpID[i]]].prop_dict = get(feed_dict, `feed.${unitOpID[i]}.prop_dict`, '');
        unitop_dict[unitOpName[unitOpID[i]]].cb_ion_dict = get(feed_dict, `feed.${unitOpID[i]}.cb_ion_dict`, '');
        unitop_dict[unitOpName[unitOpID[i]]].molal_dict = get(feed_dict, `feed.${unitOpID[i]}.molal_dict`, '');
        unitop_dict[unitOpName[unitOpID[i]]].sat_indices = get(feed_dict, `feed.${unitOpID[i]}.sat_indices`, '');
        // unitop_dict[unitOpName[unitOpID[i]]].hardness = get(feed_dict, `feed.${unitOpID[i]}.hardness`, '');
        unitop_dict[unitOpName[unitOpID[i]]].hardness = feed_hardness;
        unitop_dict[unitOpName[unitOpID[i]]].ionic_strength = get(feed_dict, `feed.${unitOpID[i]}.ionic_strength`, '');
        unitop_dict[unitOpName[unitOpID[i]]].water_source = get(feed_dict, `feed.${unitOpID[i]}.water_source`, '');
        unitop_dict[unitOpName[unitOpID[i]]].is_nf_module = get(feed_dict, `feed.${unitOpID[i]}.is_nf_module`, '');
        // const final_table_dict_1 = get(feed_dict, `feed.${unitOpID[i]}.final_table_dict`, '')
        // final_table_dict ={
        //   final_table_dict_1
        // }
      }
      if (isObjectEmpty(feed_dict) && includes(lowerCase(unitOpID[i]), 'wateranalysis')) {

        // By Kranthi on 29-9-25 : adding Water comp analysis in argo analyzer
        const ppm_dict = get(feed_dict, `feed.${unitOpID[i]}.ion_ppm_dict`, '');
        const hadns = get(feed_dict, `feed.${unitOpID[i]}.hardness`, '');

        let feed_hardness = 0;
        if (hadns === 0 && ppm_dict['Ca++'] > 0 || ppm_dict['Mg++'] > 0) {
          feed_hardness = (ppm_dict['Ca++'] * 2.51) + (ppm_dict['Mg++'] * 4.11);
        }
        else {
          feed_hardness = get(feed_dict, `feed.${unitOpID[i]}.hardness`, '');
        }

        unitop_dict[unitOpName[unitOpID[i]]].ppm_dict = get(feed_dict, `feed.${unitOpID[i]}.ion_ppm_dict`, '');
        unitop_dict[unitOpName[unitOpID[i]]].prop_dict = get(feed_dict, `feed.${unitOpID[i]}.prop_dict`, '');
        unitop_dict[unitOpName[unitOpID[i]]].cb_ion_dict = get(feed_dict, `feed.${unitOpID[i]}.cb_ion_dict`, '');
        unitop_dict[unitOpName[unitOpID[i]]].molal_dict = get(feed_dict, `feed.${unitOpID[i]}.molal_dict`, '');
        unitop_dict[unitOpName[unitOpID[i]]].sat_indices = get(feed_dict, `feed.${unitOpID[i]}.sat_indices`, '');
        unitop_dict[unitOpName[unitOpID[i]]].hardness = feed_hardness;
        unitop_dict[unitOpName[unitOpID[i]]].ionic_strength = get(feed_dict, `feed.${unitOpID[i]}.ionic_strength`, '');
        unitop_dict[unitOpName[unitOpID[i]]].water_source = get(feed_dict, `feed.${unitOpID[i]}.water_source`, '');
        unitop_dict[unitOpName[unitOpID[i]]].is_nf_module = get(feed_dict, `feed.${unitOpID[i]}.is_nf_module`, '');
        unitop_dict[unitOpName[unitOpID[i]]].isFeedComposition = get(feed_dict, `feed.${unitOpID[i]}.isFeedComposition`, '');
        unitop_dict.standalone_argo = true;
      }
      if (isObjectEmpty(dosing_dict) && includes(lowerCase(unitOpID[i]), 'chemicaldosing')) {
        unitop_dict[unitOpName[unitOpID[i]]].dosing_chemical = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.dosing_chemical`, '');
        unitop_dict[unitOpName[unitOpID[i]]].supplied_form = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.supplied_form`, '');
        unitop_dict[unitOpName[unitOpID[i]]].concentration_supplied = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.concentration_supplied`, '');
        unitop_dict[unitOpName[unitOpID[i]]].concentration_metered = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.concentration_metered`, '');
        unitop_dict[unitOpName[unitOpID[i]]].solution_density_supplied = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.solution_density_supplied`, '');
        unitop_dict[unitOpName[unitOpID[i]]].solution_density_metered = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.solution_density_metered`, '');
        unitop_dict[unitOpName[unitOpID[i]]].hardness_leakage = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.hardness_leakage`, '');
        unitop_dict[unitOpName[unitOpID[i]]].target_pH = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.target_pH`, '');
        unitop_dict[unitOpName[unitOpID[i]]].dosage_rate = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.dosage_rate`, '');
        unitop_dict[unitOpName[unitOpID[i]]].target_LSI = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.target_LSI`, '');
        unitop_dict[unitOpName[unitOpID[i]]].target_alk = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.target_alk`, '');
        unitop_dict[unitOpName[unitOpID[i]]].safety_factor = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.safety_factor`, '');
        unitop_dict[unitOpName[unitOpID[i]]].usage = get(dosing_dict, `Chemical_Dosing.${unitOpID[i]}.usage`, '');
      }

      if (isObjectEmpty(edi_dict) && includes(lowerCase(unitOpID[i]), 'edi')) {
        unitop_dict[unitOpName[unitOpID[i]]].flowperstack = get(edi_dict, `EDI.${unitOpID[i]}.flowperstack`, '');
        unitop_dict[unitOpName[unitOpID[i]]].rect_eff = get(edi_dict, `EDI.${unitOpID[i]}.rect_eff`, '');
        unitop_dict[unitOpName[unitOpID[i]]].model_type = get(edi_dict, `EDI.${unitOpID[i]}.model_type`, '');
        unitop_dict[unitOpName[unitOpID[i]]].rect_dc_volt = get(edi_dict, `EDI.${unitOpID[i]}.rect_dc_volt`, '');
        unitop_dict[unitOpName[unitOpID[i]]].target_resistivity = get(edi_dict, `EDI.${unitOpID[i]}.target_resistivity`, '');
        unitop_dict[unitOpName[unitOpID[i]]].target_silica = get(edi_dict, `EDI.${unitOpID[i]}.target_silica`, '');
        unitop_dict[unitOpName[unitOpID[i]]].explosion_limit_h2 = get(edi_dict, `EDI.${unitOpID[i]}.explosion_limit_h2`, '');
        unitop_dict[unitOpName[unitOpID[i]]].h2_design_sf = get(edi_dict, `EDI.${unitOpID[i]}.h2_design_sf`, '');
        unitop_dict[unitOpName[unitOpID[i]]].exposure_limit_cl2 = get(edi_dict, `EDI.${unitOpID[i]}.exposure_limit_cl2`, '');
        unitop_dict[unitOpName[unitOpID[i]]].cl2_design_sf = get(edi_dict, `EDI.${unitOpID[i]}.cl2_design_sf`, '');
        unitop_dict[unitOpName[unitOpID[i]]].co_current = get(edi_dict, `EDI.${unitOpID[i]}.co_current`, '');
        const upstrm_piping_press = get(edi_dict, `EDI.${unitOpID[i]}.upstrm_piping_press`, '');
        if (upstrm_piping_press >= 0 || upstrm_piping_press === '') {
          unitop_dict[unitOpName[unitOpID[i]]].upstrm_piping_press = upstrm_piping_press;
        }
        const selected_recovery_model = get(edi_dict, `EDI.${unitOpID[i]}.selected_recovery`, '');
        if (selected_recovery_model) {
          unitop_dict[unitOpName[unitOpID[i]]].selected_recovery = selected_recovery_model;
        }
        const ro_edi_machine_model = get(edi_dict, `EDI.${unitOpID[i]}.ro_edi_machine_model`, '');
        if (ro_edi_machine_model) {
          unitop_dict[unitOpName[unitOpID[i]]].ro_edi_machine_model = ro_edi_machine_model;
        }
        const org_flowperstack = get(edi_dict, `EDI.${unitOpID[i]}.org_flowperstack`, '');
        if (org_flowperstack) {
          unitop_dict[unitOpName[unitOpID[i]]].org_flowperstack = org_flowperstack;
        }
      }

      if (isObjectEmpty(pump_dict) && unitOpID[i].replace(/[\d_]+/g, '') === 'pump') {
        unitop_dict[unitOpName[unitOpID[i]]].discharge_press = Number(convertUnitValues_pressure(get(pump_dict, `pump.${unitOpID[i]}.discharge_pressure`, ''), (unitSet_dict.pressure ? unitSet_dict.pressure : 'atm'), 'atm'));
        unitop_dict[unitOpName[unitOpID[i]]].auto_checked = get(pump_dict, `pump.${unitOpID[i]}.auto_checked`, '');
        unitop_dict[unitOpName[unitOpID[i]]].pump_efficiency = Number(get(pump_dict, `pump.${unitOpID[i]}.pump_efficiency`, ''));
        unitop_dict[unitOpName[unitOpID[i]]].motor_efficiency = Number(get(pump_dict, `pump.${unitOpID[i]}.motor_efficiency`, ''));
        unitop_dict[unitOpName[unitOpID[i]]].vfd_efficiency = Number(get(pump_dict, `pump.${unitOpID[i]}.vfd_efficiency`, ''));
      }
      if (isObjectEmpty(recirc_dict) && unitOpID[i].replace(/[\d_]+/g, '') === 'RecircROHP') {
        unitop_dict[unitOpName[unitOpID[i]]].discharge_press = Number(convertUnitValues_pressure(get(recirc_dict, `RecircROHP.${unitOpID[i]}.discharge_pressure`, ''), (unitSet_dict.pressure ? unitSet_dict.pressure : 'atm'), 'atm'));
        unitop_dict[unitOpName[unitOpID[i]]].auto_checked = get(recirc_dict, `RecircROHP.${unitOpID[i]}.auto_checked`, '');
        unitop_dict[unitOpName[unitOpID[i]]].pump_efficiency = Number(get(recirc_dict, `RecircROHP.${unitOpID[i]}.pump_efficiency`, ''));
        unitop_dict[unitOpName[unitOpID[i]]].motor_efficiency = Number(get(recirc_dict, `RecircROHP.${unitOpID[i]}.motor_efficiency`, ''));
        unitop_dict[unitOpName[unitOpID[i]]].vfd_efficiency = Number(get(recirc_dict, `RecircROHP.${unitOpID[i]}.vfd_efficiency`, ''));
      }
      if (isObjectEmpty(recircRo_dict) && unitOpID[i].replace(/[\d_]+/g, '') === 'RecircRO') {
        unitop_dict[unitOpName[unitOpID[i]]].discharge_press = Number(convertUnitValues_pressure(get(recircRo_dict, `RecircRO.${unitOpID[i]}.discharge_pressure`, ''), (unitSet_dict.pressure ? unitSet_dict.pressure : 'atm'), 'atm'));
        unitop_dict[unitOpName[unitOpID[i]]].auto_checked = get(recircRo_dict, `RecircRO.${unitOpID[i]}.auto_checked`, '');
        unitop_dict[unitOpName[unitOpID[i]]].pump_efficiency = Number(get(recircRo_dict, `RecircRO.${unitOpID[i]}.pump_efficiency`, ''));
        unitop_dict[unitOpName[unitOpID[i]]].motor_efficiency = Number(get(recircRo_dict, `RecircRO.${unitOpID[i]}.motor_efficiency`, ''));
        unitop_dict[unitOpName[unitOpID[i]]].vfd_efficiency = Number(get(recircRo_dict, `RecircRO.${unitOpID[i]}.vfd_efficiency`, ''));
      }

      if (isObjectEmpty(hp_pump_dict) && includes(lowerCase(unitOpID[i]), 'hppump')) {
        unitop_dict[unitOpName[unitOpID[i]]].discharge_press = 0.0;
        unitop_dict[unitOpName[unitOpID[i]]].auto_checked = get(hp_pump_dict, `hppump.${unitOpID[i]}.auto_checked`, '');
        unitop_dict[unitOpName[unitOpID[i]]].pump_efficiency = Number(get(hp_pump_dict, `hppump.${unitOpID[i]}.pump_efficiency`, ''));
        unitop_dict[unitOpName[unitOpID[i]]].motor_efficiency = Number(get(hp_pump_dict, `hppump.${unitOpID[i]}.motor_efficiency`, ''));
        unitop_dict[unitOpName[unitOpID[i]]].vfd_efficiency = Number(get(hp_pump_dict, `hppump.${unitOpID[i]}.vfd_efficiency`, ''));
        let find_hppump_fromERD;
        if (wexpex_all_unitop.length) {
          find_hppump_fromERD = wexpex_all_unitop.filter((item) => { if (item.id === unitOpID[i]) { return item.id; } })[0];
        } else if (peltonwheel_all_unitop.length) {
          find_hppump_fromERD = peltonwheel_all_unitop.filter((item) => { if (item.id === unitOpID[i]) { return item.id; } })[0];
        } else if (turbocharger_all_unitop) {
          find_hppump_fromERD = turbocharger_all_unitop.filter((item) => { if (item.id === unitOpID[i]) { return item.id; } })[0];
        }
        // else if (clro_all_unitop) {
        //   find_hppump_fromERD = clro_all_unitop.filter((item) => { if (item.id === unitOpID[i]) { return item.id; } })[0];
        // }
        // to check whether hppump present in WEX if yes then its connected from mixsplit else connected from roPump
        if (find_hppump_fromERD === undefined) {
          if (unitOpName[connectionInfo_source_target[unitOpID[i]]] && connectionInfo_source_target[unitOpID[i]].includes('roPump') && unitop_dict[unitOpName[connectionInfo_source_target[unitOpID[i]]]] !== undefined) {
            if (unitop_dict[unitOpName[connectionInfo_source_target[unitOpID[i]]]]['Unit Type'] === 'CLRO') {
              unitop_dict[unitOpName[connectionInfo_source_target[unitOpID[i]]]].clro_param_dict.hp_pump_data = unitop_dict[unitOpName[unitOpID[i]]];
            } else {
              unitop_dict[unitOpName[connectionInfo_source_target[unitOpID[i]]]].ro_param_dict.hp_pump_data = unitop_dict[unitOpName[unitOpID[i]]];
            }
          }
          if (unitOpName[connectionInfo_source_target[unitOpID[i]]] && connectionInfo_source_target[unitOpID[i]].includes('nfPump') && unitop_dict[unitOpName[connectionInfo_source_target[unitOpID[i]]]] !== undefined) {
            unitop_dict[unitOpName[connectionInfo_source_target[unitOpID[i]]]].ro_param_dict.hp_pump_data = unitop_dict[unitOpName[unitOpID[i]]];
          }
        }
      }
      if (isObjectEmpty(stripper_dict) && includes(lowerCase(unitOpID[i]), 'stripper')) {
        unitop_dict[unitOpName[unitOpID[i]]].stripper_flag = get(stripper_dict, `st.${unitOpID[i]}.stripper_flag`, '');
        unitop_dict[unitOpName[unitOpID[i]]].target_co2 = Number(get(stripper_dict, `st.${unitOpID[i]}.target_co2`, ''));
        unitop_dict[unitOpName[unitOpID[i]]].target_h2s = Number(get(stripper_dict, `st.${unitOpID[i]}.target_h2s`, ''));
        unitop_dict[unitOpName[unitOpID[i]]].target_nh3 = Number(get(stripper_dict, `st.${unitOpID[i]}.target_nh3`, ''));
      }
      if (isObjectEmpty(work_exc) && includes(lowerCase(unitOpID[i]), 'wex')) {
        unitop_dict[unitOpName[unitOpID[i]]].erd_type = get(work_exc, `work_exc.${unitOpID[i]}.erd_type`, {});
        unitop_dict[unitOpName[unitOpID[i]]].is_auto = get(work_exc, `work_exc.${unitOpID[i]}.is_auto`, {});
        unitop_dict[unitOpName[unitOpID[i]]].lp_dicharge_pres = get(work_exc, `work_exc.${unitOpID[i]}.lp_dicharge_pres`, {});
        unitop_dict[unitOpName[unitOpID[i]]].leakage = get(work_exc, `work_exc.${unitOpID[i]}.leakage`, {});
        unitop_dict[unitOpName[unitOpID[i]]].cost_power = get(work_exc, `work_exc.${unitOpID[i]}.cost_power`, {});
        unitop_dict[unitOpName[unitOpID[i]]].cir_m_eff = get(work_exc, `work_exc.${unitOpID[i]}.cir_m_eff`, {});
        unitop_dict[unitOpName[unitOpID[i]]].cir_p_eff = get(work_exc, `work_exc.${unitOpID[i]}.cir_p_eff`, {});
        unitop_dict[unitOpName[unitOpID[i]]].cir_vfd_eff = get(work_exc, `work_exc.${unitOpID[i]}.cir_vfd_eff`, {});
      }
      if (isObjectEmpty(pelton_exc) && includes(lowerCase(unitOpID[i]), 'peltonwheel')) {
        unitop_dict[unitOpName[unitOpID[i]]].erd_type = get(pelton_exc, `pelton_exc.${unitOpID[i]}.erd_type`, {});
        unitop_dict[unitOpName[unitOpID[i]]].lp_dicharge_pres = get(pelton_exc, `pelton_exc.${unitOpID[i]}.lp_dicharge_pres`, {});
        unitop_dict[unitOpName[unitOpID[i]]].cost_power = get(pelton_exc, `pelton_exc.${unitOpID[i]}.cost_power`, {});
        unitop_dict[unitOpName[unitOpID[i]]].turbine_eff = get(pelton_exc, `pelton_exc.${unitOpID[i]}.turbine_eff`, {});
      }
      // TurboCharger execution
      if (isObjectEmpty(turbo_exc) && includes(lowerCase(unitOpID[i]), 'tc')) {
        unitop_dict[unitOpName[unitOpID[i]]].erd_type = get(turbo_exc, `TRD_data.${unitOpID[i]}.erd_type`, {});
        unitop_dict[unitOpName[unitOpID[i]]].lp_dicharge_pres = get(turbo_exc, `TRD_data.${unitOpID[i]}.lp_dicharge_pres`, {});
        unitop_dict[unitOpName[unitOpID[i]]].cost_power = get(turbo_exc, `TRD_data.${unitOpID[i]}.cost_power`, {});
        unitop_dict[unitOpName[unitOpID[i]]].net_efficiency = get(turbo_exc, `TRD_data.${unitOpID[i]}.net_efficiency`, {});
        unitop_dict[unitOpName[unitOpID[i]]].turbo_on_stage = get(turbo_exc, `TRD_data.${unitOpID[i]}.turbo_on_stage`, {});
      }
      if (isObjectEmpty(cf_dict) && includes(lowerCase(unitOpID[i]), 'cartridge')) {
        unitop_dict[unitOpName[unitOpID[i]]].filter_type = get(cf_dict, `cf.${unitOpID[i]}.Filter`, '');
        unitop_dict[unitOpName[unitOpID[i]]].filter_type = get(cf_dict, `cf.${unitOpID[i]}.Filter`, '');
        unitop_dict[unitOpName[unitOpID[i]]].flow_per_tie = get(cf_dict, `cf.${unitOpID[i]}.flow_per_tie`, '');
        unitop_dict[unitOpName[unitOpID[i]]].flow_per_tie = get(cf_dict, `cf.${unitOpID[i]}.flow_per_tie`, '');
      }
      if (localStorage.getItem('ro_payload') && includes(unitOpID[i], 'Argo')) {
        // Retrieve the argo configuration dictionary for the current Argo unit operation from ro_payload
        const argo_dict = get(ro_payload, `ro.${unitOpID[i]}.argo_dict`);
        // Validate Argo Analyzer antiscalant compatibility with the current region
        // Only perform validation if argo_dict exists and region access check fails
        if (argo_dict && !getRegionAccess(dbTransactionDetails)) {
          // Check if the selected antiscalant product is available in the current region
          if (!isProductAvailableInRegion(dbTransactionDetails, argo_dict)) {
            // Display error message if antiscalant is not supported in this region
            openModelPopUp('Selected Antiscalant in Argo Analyzer is not supported in this region. Please select the correct Antiscalant to proceed.', 'Warning', 'warning');
            return;
          }
          // Retrieve the current region from session storage
          const currentRegion = sessionStorage.getItem('Region');
          // Get the user's previously selected region from argo configuration
          const userRegion = argo_dict.user_region;
          // Update user region if it differs from current region
          if (userRegion !== currentRegion) {
            argo_dict.user_region = currentRegion;
          }
          // If no user region is set, initialize it with current region and default antiscalant
          else if (!userRegion) {
            argo_dict.user_region = currentRegion;
            argo_dict.antiscalant = 'UNTREATED';
          }
        } else if (argo_dict && !isProductAvailableInRegionforAccessUsers(dbTransactionDetails, argo_dict)) {
          // Display error message if antiscalant is not supported in this region
          openModelPopUp('Selected Antiscalant in Argo Analyzer is not supported in this region. Please select the correct Antiscalant to proceed.', 'Warning', 'warning');
          return;
        }
        if (argo_dict && !hasUserRegionKey(argo_dict)) {
          argo_dict.user_region = sessionStorage.getItem('Region');
        }
        // Assign the argo configuration dictionary to the current unit operation in unitop_dict
        unitop_dict[unitOpName[unitOpID[i]]].argo_dict = argo_dict;
      }
      const clrttemp = JSON.parse(localStorage.getItem('ro_payload')) || {};  // {}
      const clrodictTEmp = JSON.stringify(clrttemp[Object.keys(clrttemp)[0]]) === '{}';
      if (localStorage.getItem('ro_payload') && includes(unitOpID[i], 'ro_')) {
        // Check if ro_payload exists in localStorage and the current unit operation ID contains 'ro_'
        // Retrieve the RO configuration dictionary for the current unit operation from ro_payload
        const ro_dict = get(ro_payload, `ro.${unitOpID[i]}`, {});
        // Validate Argo Analyzer antiscalant compatibility with the current region
        // Only perform validation if argo_dict exists and region access check fails
        if (ro_dict?.argo_dict && !getRegionAccess(dbTransactionDetails)) {
          // Check if the selected antiscalant product is available in the current region
          if (!isProductAvailableInRegion(dbTransactionDetails, ro_dict.argo_dict)) {
            // Display error message if antiscalant is not supported in this region
            openModelPopUp('Selected Antiscalant in Argo Analyzer is not supported in this region. Please select the correct Antiscalant to proceed.', 'Warning', 'warning');
            return;
          }
          // Retrieve the current region from session storage
          const currentRegion = sessionStorage.getItem('Region');
          // Get the user's previously selected region from argo configuration
          const userRegion = ro_dict.argo_dict.user_region;
          // Update user region if it differs from current region
          if (userRegion !== currentRegion) {
            ro_dict.argo_dict.user_region = currentRegion;
          }
          // If no user region is set, initialize it with current region and default antiscalant
          else if (!userRegion) {
            ro_dict.argo_dict.user_region = currentRegion;
            ro_dict.argo_dict.antiscalant = 'UNTREATED';
          }
        } else if (ro_dict?.argo_dict && !isProductAvailableInRegionforAccessUsers(dbTransactionDetails, ro_dict?.argo_dict)) {
          // Display error message if antiscalant is not supported in this region
          openModelPopUp('Selected Antiscalant in Argo Analyzer is not supported in this region. Please select the correct Antiscalant to proceed.', 'Warning', 'warning');
          return;
        }
        if (ro_dict?.argo_dict && !hasUserRegionKey(ro_dict.argo_dict)) {
          ro_dict.argo_dict.user_region = sessionStorage.getItem('Region');
        }
        unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict = ro_dict; // ro_dict;
      }
      if (localStorage.getItem('ro_payload') && includes(unitOpID[i], 'nf_')) {
        // if (localStorage.getItem('ro_payload') && includes(lowerCase(unitOpID[i]), 'ro_')) {
        unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict = get(ro_payload, `ro.${unitOpID[i]}`, {}); // ro_dict;
        unitop_dict[unitOpName[unitOpID[i]]]['Unit Type'] = 'RO';
        unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.is_nf_module = true;
      }
      if (localStorage.getItem('ro_payload') && includes(unitOpID[i], 'roPump') && !clrodictTEmp) {
        // Retrieve the RO configuration dictionary for the current unit operation from ro_payload
        const ro_dict = get(ro_payload, `ro.${unitOpID[i]}`, {});
        // Validate Argo Analyzer antiscalant compatibility with the current region
        // Only perform validation if argo_dict exists and region access check fails
        if (ro_dict?.argo_dict && !getRegionAccess(dbTransactionDetails)) {
          // Check if the selected antiscalant product is available in the current region
          if (!isProductAvailableInRegion(dbTransactionDetails, ro_dict.argo_dict)) {
            // Display error message if antiscalant is not supported in this region
            openModelPopUp('Selected Antiscalant in Argo Analyzer is not supported in this region. Please select the correct Antiscalant to proceed.', 'Warning', 'warning');
            return;
          }
          // Retrieve the current region from session storage
          const currentRegion = sessionStorage.getItem('Region');
          // Get the user's previously selected region from argo configuration
          const userRegion = ro_dict.argo_dict.user_region;
          // Update user region if it differs from current region
          if (userRegion !== currentRegion) {
            ro_dict.argo_dict.user_region = currentRegion;
          }
          // If no user region is set, initialize it with current region and default antiscalant
          else if (!userRegion) {
            ro_dict.argo_dict.user_region = currentRegion;
            ro_dict.argo_dict.antiscalant = 'UNTREATED';
          }
        } else if (ro_dict?.argo_dict && !isProductAvailableInRegionforAccessUsers(dbTransactionDetails, ro_dict?.argo_dict)) {
          // Display error message if antiscalant is not supported in this region
          openModelPopUp('Selected Antiscalant in Argo Analyzer is not supported in this region. Please select the correct Antiscalant to proceed.', 'Warning', 'warning');
          return;
        }
        if (ro_dict?.argo_dict && !hasUserRegionKey(ro_dict.argo_dict)) {
          ro_dict.argo_dict.user_region = sessionStorage.getItem('Region');
        }
        unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict = ro_dict; // ro_dict;
        // this code belongs to WEX/PEX Start
        const isMixSplitConnectedWithRO = Object.keys(connectionInfo_source_target).find(key => connectionInfo_source_target[key] === unitOpID[i]);
        if (includes(lowerCase(isMixSplitConnectedWithRO), 'mixsplit')) {
          const isHPPumpConnectedWithMixSplit = Object.keys(connectionInfo_source_target).filter((item) => { if (connectionInfo_source_target[item] === isMixSplitConnectedWithRO) return item; });
          isHPPumpConnectedWithMixSplit.forEach((item) => {
            if (item.includes('hppump')) {
              unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_data = unitop_dict[unitOpName[item]];
            }
          });
        }
        else {
          const find_hppump = getKeyByValue(connectionInfo_source_target, unitOpID[i]);
          // unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_data = JSON.parse(localStorage.getItem(find_hppump));

          Object.keys(connectionInfo_source_target).filter((item) => {
            if (item.includes(find_hppump)) {
              unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_data = unitop_dict[unitOpName[item]];
            }
          });
        }

        // end
        // unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_dict = JSON.parse(localStorage.getItem(lowerCase(getKeyByValue(connectionInfo_source_target, unitOpID[i]))));

        // Object.keys(connectionInfo_source_target).filter((item) => {
        //   if (item.includes('hppump')) {
        //     unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_data = unitop_dict[unitOpName[item]];
        //   }
        // });
      }
      if (localStorage.getItem('ro_payload') && includes(unitOpID[i], 'nfPump')) {
        unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict = get(ro_payload, `ro.${unitOpID[i]}`, {}); // ro_dict;
        unitop_dict[unitOpName[unitOpID[i]]]['Unit Type'] = 'RO_HP';
        unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.is_nf_module = true;
        // this code belongs to WEX/PEX Start
        // const isMixSplitConnectedWithRO = Object.keys(connectionInfo_source_target).find(key => connectionInfo_source_target[key] === unitOpID[i]);
        // if (includes(lowerCase(isMixSplitConnectedWithRO), 'mixsplit')) {
        //   const isHPPumpConnectedWithMixSplit = Object.keys(connectionInfo_source_target).filter((item) => { if (connectionInfo_source_target[item] === isMixSplitConnectedWithRO) return item; });
        //   isHPPumpConnectedWithMixSplit.forEach((item) => {
        //     if (item.includes('hppump')) {
        //       unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_data = unitop_dict[unitOpName[item]];
        //     }
        //   });
        // }
        // else {
        const find_hppump = getKeyByValue(connectionInfo_source_target, unitOpID[i]);
        Object.keys(connectionInfo_source_target).filter((item) => {
          if (item.includes(find_hppump)) {
            unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_data = unitop_dict[unitOpName[item]];
          }
        });
        // }
      }
      if (localStorage.getItem('clro_payload') && includes(unitOpID[i], 'roPump')) {
        // Retrieve the CLRO (Closed Loop RO) configuration dictionary for the current unit operation from clro_payload
        const clro_dict = get(clro_payload, `ro.${unitOpID[i]}`, {});
        // Validate Argo Analyzer antiscalant compatibility with the current region
        // Only perform validation if argo_dict exists and region access check fails
        if (clro_dict?.argo_dict && !getRegionAccess(dbTransactionDetails)) {
          // Check if the selected antiscalant product is available in the current region
          if (!isProductAvailableInRegion(dbTransactionDetails, clro_dict.argo_dict)) {
            // Display error message if antiscalant is not supported in this region
            openModelPopUp('Selected Antiscalant in Argo Analyzer is not supported in this region. Please select the correct Antiscalant to proceed.', 'Warning', 'warning');
            return;
          }

          // Retrieve the current region from session storage
          const currentRegion = sessionStorage.getItem('Region');
          // Get the user's previously selected region from argo configuration
          const userRegion = clro_dict.argo_dict.user_region;

          // Update user region if it differs from current region
          if (userRegion !== currentRegion) {
            clro_dict.argo_dict.user_region = currentRegion;
          }
          // If no user region is set, initialize it with current region and default antiscalant
          else if (!userRegion) {
            clro_dict.argo_dict.user_region = currentRegion;
            clro_dict.argo_dict.antiscalant = 'UNTREATED';
          }
        } else if (clro_dict?.argo_dict && !isProductAvailableInRegionforAccessUsers(dbTransactionDetails, clro_dict?.argo_dict)) {
          // Display error message if antiscalant is not supported in this region
          openModelPopUp('Selected Antiscalant in Argo Analyzer is not supported in this region. Please select the correct Antiscalant to proceed.', 'Warning', 'warning');
          return;
        }
        if (clro_dict?.argo_dict && !hasUserRegionKey(clro_dict.argo_dict)) {
          clro_dict.argo_dict.user_region = sessionStorage.getItem('Region');
        }
        // Assign the CLRO configuration dictionary to the current unit operation in unitop_dict
        unitop_dict[unitOpName[unitOpID[i]]].clro_param_dict = clro_dict;
        // Deleting clro_param_dict empty obj if unitType is RO-HP by Abhishek on 12-Dec-23
        if (unitop_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'RO_HP') {
          delete unitop_dict[unitOpName[unitOpID[i]]].clro_param_dict;
        }

        const find_hppump = getKeyByValue(connectionInfo_source_target, unitOpID[i]);

        Object.keys(connectionInfo_source_target).filter((item) => {
          if (item.includes(find_hppump)) {
            // unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_data = unitop_dict[unitOpName[item]];
          }
        });
      }
      if (includes(lowerCase(unitOpID[i]), 'mixsplit')) {
        wexpex_all_unitop.forEach(
          (item, index) => {
            if (item.id === unitOpID[i]) {
              outgoing_connection.filter((val) => {
                if (val.UnitOp === item.id && val.Outgoing.includes('hppump')) {
                  Mix_Split1_HP_val = [val.stream];
                }
                if (val.UnitOp === item.id && val.Outgoing.includes('wex')) {
                  Mix_Split1_ERD_val = [val.stream];
                }
              });

              incoming_connection.filter((val) => {
                if (val.UnitOp === item.id && index === 0) {
                  Mix_Split1_Feed_val = [val.stream];
                }
                else if (val.UnitOp === item.id && val.Incoming.includes('hppump')) {
                  Mix_Split2_HP_val = [val.stream];
                }
                // @sudarsana updated 'boosterpump' inplace of 'wex'
                else if (val.UnitOp === item.id && val.Incoming.includes('boosterpump')) {
                  Mix_Split2_Booster_val = [val.stream];
                }
              });
            }
          });

      }

      if (includes(lowerCase(unitOpID[i]), 'wex')) {
        wexpex_all_unitop.forEach(
          (item) => {
            if (item.id === unitOpID[i]) {
              outgoing_connection.filter((val) => {
                if (val.UnitOp === item.id && val.port === 'd_w') {
                  ERD_Waste_val = [val.stream];
                }
                // @sudarsana add condtion for ERD Booster stream number
                if (val.UnitOp === item.id && val.port === 'b_w') {
                  ERD_Booster_val = [val.stream];
                }
              });
            }
          });
      }

      // if (includes(lowerCase(unitOpID[i]), 'mixsplit')) {
      //   wexpex_all_unitop.forEach((item) => {
      //     if (item.id === unitOpID[i]) {

      //     }

      //   });
      // }
      if (mixSplit_dict[unitOpID[i]] && localStorage.getItem('mixSplit-dict') && includes(lowerCase(unitOpID[i]), 'mixsplit')) {
        Object.entries(mixSplit_dict[unitOpID[i]]).forEach(([key, value]) => {
          unitop_dict[unitOpName[unitOpID[i]]][key.split('stream')[1]] = value;
        });
      }
    }
    // for (let i = 0; i < unitOpID.length; i++) {
    //   if (includes(lowerCase(unitOpID[i]), 'cls')) {
    //     unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict = JSON.parse(localStorage.getItem(unitOpID[i])); // ro_dict;
    //   }
    // }
    for (let i = 0; i < unitOpID.length; i += 1) {
      peltonwheel_all_unitop.forEach((item, index) => {
        if (item.id === unitOpID[i] && includes(unitOpID[i], 'roPump')) {
          unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] = 'RO_PW';
          unitop_dict[unitOpName[unitOpID[i]]]['Unit Type'] = 'RO_PW';
          if (!findAllConnection) {
            unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.turbo_data = get(pelton_exc, `pelton_exc.${peltonwheel_all_unitop[index - 1].id}`, {});
            unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.turbo_data.name = unitOpName[peltonwheel_all_unitop[index - 1].id];
          }
        }
      });
    }

    for (let i = 0; i < unitOpID.length; i += 1) {
      turbocharger_all_unitop.forEach((item, index) => {
        if (item.id === unitOpID[i] && includes(unitOpID[i], 'roPump')) {
          unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] = 'RO_TC';
          unitop_dict[unitOpName[unitOpID[i]]]['Unit Type'] = 'RO_TC';
          if (!findAllConnection) {
            unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.turbo_data = get(turbo_exc, `TRD_data.${turbocharger_all_unitop[index - 1].id}`, {});
            unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.turbo_data.name = unitOpName[turbocharger_all_unitop[index - 1].id];
            unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_data = unitop_dict[unitOpName[turbocharger_all_unitop[0].id]];
          }
        }
      });
    }
    // ##################  Re-alignment of all the unitop in WEX ##############
    for (let i = 0; i < unitOpID.length; i += 1) {
      wexpex_all_unitop.forEach((item, index) => {
        if (item.id === unitOpID[i] && includes(unitOpID[i], 'roPump')) {
          unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] = 'RO_ERD';
          unitop_dict[unitOpName[unitOpID[i]]]['Unit Type'] = 'RO_ERD';
          if (!findAllConnection) {
            unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.erd_data = get(work_exc, `work_exc.${wexpex_all_unitop[index - 2].id}`, {});

            unit_op_dict[unitOpName[unitOpID[i]]].Mix_Split1_Feed = Mix_Split1_Feed_val;
            unitop_dict[unitOpName[unitOpID[i]]].Mix_Split1_Feed = Mix_Split1_Feed_val;

            unit_op_dict[unitOpName[unitOpID[i]]].Mix_Split1_HP = Mix_Split1_HP_val;
            unitop_dict[unitOpName[unitOpID[i]]].Mix_Split1_HP = Mix_Split1_HP_val;

            unit_op_dict[unitOpName[unitOpID[i]]].Mix_Split1_ERD = Mix_Split1_ERD_val;
            unitop_dict[unitOpName[unitOpID[i]]].Mix_Split1_ERD = Mix_Split1_ERD_val;

            unit_op_dict[unitOpName[unitOpID[i]]].Mix_Split2_HP = Mix_Split2_HP_val;
            unitop_dict[unitOpName[unitOpID[i]]].Mix_Split2_HP = Mix_Split2_HP_val;
            // @sudarsana here removed Mix_Split2_ERD and added as Mix_Split2_Booster
            unit_op_dict[unitOpName[unitOpID[i]]].Mix_Split2_Booster = Mix_Split2_Booster_val;
            unitop_dict[unitOpName[unitOpID[i]]].Mix_Split2_Booster = Mix_Split2_Booster_val;

            unit_op_dict[unitOpName[unitOpID[i]]].ERD_Waste = ERD_Waste_val;
            unitop_dict[unitOpName[unitOpID[i]]].ERD_Waste = ERD_Waste_val;
            // @sudarsana added ERD_Bosster
            unit_op_dict[unitOpName[unitOpID[i]]].ERD_Booster = ERD_Booster_val;
            unitop_dict[unitOpName[unitOpID[i]]].ERD_Booster = ERD_Booster_val;

            const recovery = unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.recovery / 100;
            // split fraction value for 1st mixsplit in WEX
            // Product [0] is the stream number of MixSplit1 to ERD connection
            // Product [1] is the stream number of MixSplit1 to pump connection
            // 5 is the length of wexpex_all_unitop list hence last element postion would be 4
            unitop_dict[unitOpName[wexpex_all_unitop[index - 4].id]][unitop_dict[unitOpName[wexpex_all_unitop[index - 4].id]].Product[0]] = 1 - recovery;
            unitop_dict[unitOpName[wexpex_all_unitop[index - 4].id]][unitop_dict[unitOpName[wexpex_all_unitop[index - 4].id]].Product[1]] = recovery;
          }
        }
      });

      // wexpex_all_unitop.forEach(
      //   (item) => {
      //     if (item.id === unitOpID[i] && includes(lowerCase(unitOpID[i]), 'mixsplit')) {
      //       if (unitop_dict[unitOpName[unitOpID[i]]].Product.length > 1)
      //       {
      //         unitop_dict[unitOpName[unitOpID[i]]][unitop_dict[unitOpName[unitOpID[i]]].Product[0]] = value;
      //       }
      //     }
      //   });
    }
    // First mark feedbleed_subnet = true for all custom_all_ROHPLoop IDs
    custom_all_ROHPLoop.forEach(node => {
      const unitName = unitOpName[node.id];
      if (unitop_dict[unitName]) {
        unitop_dict[unitName].feedbleed_subnet = true;
      }
    });
    custom_all_ROLoop.forEach(node => {
      const unitName = unitOpName[node.id];
      if (unitop_dict[unitName]) {
        unitop_dict[unitName].feedbleed_subnet = true;
      }
    });
    for (let i = 0; i < unitOpID.length; i += 1) {
      if (unitOpID[i].includes('roHPPumpRoHPLoop')) {
        const unitName = unitOpName[unitOpID[i]];
        const roNode = custom_all_ROHPLoop.find(u => u.id === unitOpID[i]);
        const parentGroup = roNode?.parentNode;

        // Mixer inlet: hppump → mixsplit in same group
        const mixerConn = outgoing_connection.find(val =>
          val.UnitOp.startsWith('hppump') &&
          custom_all_ROHPLoop.find(u => u.id === val.UnitOp)?.parentNode === parentGroup
        );
        const Mix_Inlet_val_ROHP = mixerConn ? [mixerConn.stream] : [];

        // HP_Pump inlet: mixsplit → HP_Pump in same group
        const recircConn = outgoing_connection.find(val =>
          val.UnitOp.startsWith('mixsplit') &&
          val.Outgoing.startsWith('RecircROHP') &&
          custom_all_ROHPLoop.find(u => u.id === val.Outgoing)?.parentNode === parentGroup
        );
        const Rec_Inlet_Val_ROHP = recircConn ? [recircConn.stream] : [];

        // Find the downstream mixsplit connected to this RO pump
        const downstreamSplit = outgoing_connection.find(val =>
          val.UnitOp === unitOpID[i] && val.Outgoing.startsWith('mixsplit')
        );

        let Mix_Outlet_val_ROHP = [];
        let splitter_name = '';

        if (downstreamSplit) {
          // Get the branch from that mixsplit going back upstream
          const splitConn = outgoing_connection.find(val =>
            val.UnitOp === downstreamSplit.Outgoing && val.Outgoing.startsWith('mixsplit')
          );
          Mix_Outlet_val_ROHP = splitConn ? [splitConn.stream] : [];

          // Assign the actual mixsplit node name
          splitter_name = downstreamSplit.Outgoing;   // e.g. "mixsplit_2"
        }
        // Bleed: mixsplit → wasteout in same group
        const bleedConn = outgoing_connection.find(val =>
          val.Outgoing.startsWith('wasteout') &&
          custom_all_ROHPLoop.find(u => u.id === val.UnitOp)?.parentNode === parentGroup
        );
        const Waste_Outlet_val_ROHP = bleedConn ? [bleedConn.stream] : [];

        // // Find hp pump in same group
        // const hpNode = custom_all_ROHPLoop.find(u =>
        //   u.parentNode === parentGroup && u.id.startsWith('hppump')
        // );

        // // Find recirc pump in same group
        // const recircNode = custom_all_ROHPLoop.find(u =>
        //   u.parentNode === parentGroup && u.id.startsWith('RecircROHP')
        // );

        // Assign everything
        unitop_dict[unitName].ro_param_dict = get(ro_payload, `ro.${unitOpID[i]}`, {});
        unitop_dict[unitName].Mixer_inlet = Mix_Inlet_val_ROHP;
        unitop_dict[unitName].Recirc_inlet = Rec_Inlet_Val_ROHP;
        unitop_dict[unitName].Splitter_outlet = Mix_Outlet_val_ROHP;
        unitop_dict[unitName].bleed = Waste_Outlet_val_ROHP;
        unitop_dict[unitName].splitter_name =  unitop_dict?.[unitOpName?.[splitter_name]]?.name;

        function getUpstreamHpPump(connectionMap, roLoopId) {
          let current = roLoopId;
          // Walk backwards until we find an hppump
          while (current) {
            const upstream = getKeyByValue(connectionMap, current);
            if (!upstream) break;
            if (upstream.startsWith('hppump')) {
              return upstream; // found the hp pump id
            }
            current = upstream;
          }
          return null;
        }

        function getUpstreamRecirc(connectionMap, roLoopId) {
          let current = roLoopId;
          while (current) {
            const upstream = getKeyByValue(connectionMap, current);
            if (!upstream) break;
            if (upstream.startsWith('RecircROHP')) {
              return upstream; // found the recirc id
            }
            current = upstream;
          }
          return null;
        }

        // Usage inside your loop
        const hpPumpId = getUpstreamHpPump(connectionInfo_source_target, unitOpID[i]);
        const recircId = getUpstreamRecirc(connectionInfo_source_target, unitOpID[i]);

        if (hpPumpId) {
          unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_data =
            unitop_dict[unitOpName[hpPumpId]];
        }

        if (recircId) {
          unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.recirc_pump_data =
            unitop_dict[unitOpName[recircId]];
        }
        const recoveryVal = unitop_dict[unitName].ro_param_dict.recovery || 0;
        const feed_flow = unitop_dict[unitName].ro_param_dict.feed_hsg || 0;
        delete unitop_dict[unitName].ro_param_dict.feed_hsg;
        const reject_flow = unitop_dict[unitName].ro_param_dict.reject_hsg || 0;
        delete unitop_dict[unitName].ro_param_dict.reject_hsg;
        const stageDict = unitop_dict[unitName].ro_param_dict.stage_param_dict || {};
        const firstStage = stageDict[0] || {};
        const number_vessels = firstStage.num_vessels || 0;
        unitop_dict[unitName].feedbleed_data = {
          loop_recovery: recoveryVal,
          feed_hsg: feed_flow,
          reject_hsg: reject_flow,
          n_hsg: number_vessels
        };
      }
      if (unitOpID[i].includes('ropumpRoLoop')) {
        const unitName = unitOpName[unitOpID[i]];
        const roNode = custom_all_ROLoop.find(u => u.id === unitOpID[i]);
        const parentGroup = roNode?.parentNode;

        // all node ids inside custom_all_ROLoop
        const roLoopIds = custom_all_ROLoop.map((u) => u.id);

        // mixsplit nodes only in current group
        const mixsplitIdsInGroup = custom_all_ROLoop
          .filter(
            (u) =>
              u.parentNode === parentGroup &&
              u.id.startsWith('mixsplit')
          )
          .map((u) => u.id);

        // get feed/mixer inlet connection:
        // outgoing goes to mixsplit in same group,
        // but UnitOp should NOT be from custom_all_ROLoop
        const mixerConn = outgoing_connection.find(
          (val) =>
            mixsplitIdsInGroup.includes(val.Outgoing) &&
            !roLoopIds.includes(val.UnitOp)
        );

        const Mix_Inlet_val_RO = mixerConn ? [mixerConn.stream] : [];
        // const Mix_Inlet_val_ROHP = mixerConn ? [mixerConn.stream] : [];

        // HP_Pump inlet: mixsplit → HP_Pump in same group
        const recircConn = outgoing_connection.find(val =>
          val.UnitOp.startsWith('mixsplit') &&
          val.Outgoing.startsWith('RecircRO') &&
          custom_all_ROLoop.find(u => u.id === val.Outgoing)?.parentNode === parentGroup
        );
        const Rec_Inlet_Val_RO = recircConn ? [recircConn.stream] : [];

        // Find the downstream mixsplit connected to this RO pump
        const downstreamSplit = outgoing_connection.find(val =>
          val.UnitOp === unitOpID[i] && val.Outgoing.startsWith('mixsplit')
        );

        let Mix_Outlet_val_RO = [];
        let splitter_name = '';

        if (downstreamSplit) {
          // Get the branch from that mixsplit going back upstream
          const splitConn = outgoing_connection.find(val =>
            val.UnitOp === downstreamSplit.Outgoing && val.Outgoing.startsWith('mixsplit')
          );
          Mix_Outlet_val_RO = splitConn ? [splitConn.stream] : [];

          // Assign the actual mixsplit node name
          splitter_name = downstreamSplit.Outgoing;   // e.g. "mixsplit_2"
        }
        // Bleed: mixsplit → wasteout in same group
        const bleedConn = outgoing_connection.find(val =>
          val.Outgoing.startsWith('wasteout') &&
          custom_all_ROLoop.find(u => u.id === val.UnitOp)?.parentNode === parentGroup
        );
        const Waste_Outlet_val_ROHP = bleedConn ? [bleedConn.stream] : [];

        // // Find hp pump in same group
        // const hpNode = custom_all_ROHPLoop.find(u =>
        //   u.parentNode === parentGroup && u.id.startsWith('hppump')
        // );

        // // Find recirc pump in same group
        // const recircNode = custom_all_ROHPLoop.find(u =>
        //   u.parentNode === parentGroup && u.id.startsWith('RecircROHP')
        // );

        // Assign everything
        unitop_dict[unitName].ro_param_dict = get(ro_payload, `ro.${unitOpID[i]}`, {});
        unitop_dict[unitName].Mixer_inlet = Mix_Inlet_val_RO;
        unitop_dict[unitName].Recirc_inlet = Rec_Inlet_Val_RO;
        unitop_dict[unitName].Splitter_outlet = Mix_Outlet_val_RO;
        unitop_dict[unitName].bleed = Waste_Outlet_val_ROHP;
        unitop_dict[unitName].splitter_name = unitop_dict[unitOpName[splitter_name]].name;

        function getUpstreamHpPump(connectionMap, roLoopId) {
          let current = roLoopId;
          // Walk backwards until we find an hppump
          while (current) {
            const upstream = getKeyByValue(connectionMap, current);
            if (!upstream) break;
            if (upstream.startsWith('hppump')) {
              return upstream; // found the hp pump id
            }
            current = upstream;
          }
          return null;
        }

        function getUpstreamRecircRo(connectionMap, roLoopId) {
          let current = roLoopId;
          while (current) {
            const upstream = getKeyByValue(connectionMap, current);
            if (!upstream) break;
            if (upstream.startsWith('RecircRO')) {
              return upstream; // found the recirc id
            }
            current = upstream;
          }
          return null;
        }

        // Usage inside your loop
        // const hpPumpId = getUpstreamHpPump(connectionInfo_source_target, unitOpID[i]);
        const recircId = getUpstreamRecircRo(connectionInfo_source_target, unitOpID[i]);

        // if (hpPumpId) {
        //   unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.hp_pump_data =
        //     unitop_dict[unitOpName[hpPumpId]];
        // }

        if (recircId) {
          unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.recirc_pump_data =
            unitop_dict[unitOpName[recircId]];
        }
        const recoveryVal = unitop_dict[unitName].ro_param_dict.recovery || 0;
        const feed_flow = unitop_dict[unitName].ro_param_dict.feed_hsg || 0;
        delete unitop_dict[unitName].ro_param_dict.feed_hsg;
        const reject_flow = unitop_dict[unitName].ro_param_dict.reject_hsg || 0;
        delete unitop_dict[unitName].ro_param_dict.reject_hsg;
        const stageDict = unitop_dict[unitName].ro_param_dict.stage_param_dict || {};
        const firstStage = stageDict[0] || {};
        const number_vessels = firstStage.num_vessels || 0;
        unitop_dict[unitName].feedbleed_data = {
          loop_recovery: recoveryVal,
          feed_hsg: feed_flow,
          reject_hsg: reject_flow,
          n_hsg: number_vessels
        };
      }
    }

    // ####################### Connection Check for each unitop ###########################
    const node_connection_details = [];
    let connection_error = '';
    const node_connection_details_final = [];
    for (let i = 0; i < unitOpID.length; i += 1) {
      if (unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'Feed') {
        if (unit_op_dict[unitOpName[unitOpID[i]]].Product.length <= 0) {
          // connection_error = connection_error+', '+unitOpName[unitOpID[i]];
          node_connection_details.push(unitOpName[unitOpID[i]]);
        }
      }
      // @sudarsana Rao added Implement split-flow node validation while executing any flowsheet.
      if (unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'RO_ERD') {
        if (unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict) {
          if (unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.split_flow !== 0) {
            if (unit_op_dict[unitOpName[unitOpID[i]]].Split_flow.length <= 0) {
              node_connection_details.push(unitOpName[unitOpID[i]]);
              // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Waste), ';
            }
          }
        }
      }
      // @sudarsana Rao added Implement split-flow node validation while executing any flowsheet.
      if (unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'RO_TC') {
        if (unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict) {
          if (unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.split_flow !== 0) {
            if (unit_op_dict[unitOpName[unitOpID[i]]].Split_flow.length <= 0) {
              node_connection_details.push(unitOpName[unitOpID[i]]);
              // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Waste), ';
            }
          }
        }
      }
      // @sudarsana Rao added Implement split-flow node validation while executing any flowsheet.
      if (unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'RO_PW') {
        if (unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict) {
          if (unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.split_flow !== 0) {
            if (unit_op_dict[unitOpName[unitOpID[i]]].Split_flow.length <= 0) {
              node_connection_details.push(unitOpName[unitOpID[i]]);
              // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Waste), ';
            }
          }
        }
      }
      // @Sudarsana added for new logic if PW , TC and ERD if waste connection was incompleted it will throw error
      if (unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'PW' || unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'TC' || unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'ERD') {
        if (unitop_dict[unitOpName[unitOpID[i]]]) {
          if (unitop_dict[unitOpName[unitOpID[i]]].Waste.length <= 0) {
            node_connection_details.push(unitOpName[unitOpID[i]]);
            // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Waste), ';
          }
        }
      }
      if (unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'ProductOut' || unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'WasteOut') {
        if (unit_op_dict[unitOpName[unitOpID[i]]].Feed.length <= 0) {
          node_connection_details.push(unitOpName[unitOpID[i]]);
          // connection_error = connection_error+unitOpName[unitOpID[i]]+', ';
        }
      }
      // @sudarsana added here 'RO_PW' , 'RO_TC' and 'RO_ERD' if product is connection is missing then it will throw the error
      if (unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'RO' ||
        unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'RO_HP' ||
        unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'NF_HP' ||
        unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'NF' ||
        unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'CLRO' ||
        unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'RO_PW' ||
        unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'RO_TC' ||
        unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'roHPPumpRoHPLoop' ||
        unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'ropumpRoLoop' ||
        unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'RO_ERD') {
        if (unit_op_dict[unitOpName[unitOpID[i]]].Feed.length <= 0) {
          node_connection_details.push(unitOpName[unitOpID[i]]);
          // connection_error = connection_error+', '+unitOpName[unitOpID[i]]+'(Feed), ';
        }
        if (unit_op_dict[unitOpName[unitOpID[i]]].Product.length <= 0) {
          node_connection_details.push(unitOpName[unitOpID[i]]);
          // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Product), ';
        }
        if (unit_op_dict[unitOpName[unitOpID[i]]].Waste.length <= 0) {
          node_connection_details.push(unitOpName[unitOpID[i]]);
          // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Waste), ';
        }
        if (unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'CLRO') {
          if (unitop_dict[unitOpName[unitOpID[i]]].clro_param_dict) {
            if (unitop_dict[unitOpName[unitOpID[i]]].clro_param_dict.split_flow !== 0) {
              if (unit_op_dict[unitOpName[unitOpID[i]]].Split_flow.length <= 0) {
                node_connection_details.push(unitOpName[unitOpID[i]]);
                // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Waste), ';
              }
            }
          }
        } else if (unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict) {
          if (unitop_dict[unitOpName[unitOpID[i]]].ro_param_dict.split_flow !== 0) {
            if (unit_op_dict[unitOpName[unitOpID[i]]].Split_flow.length <= 0) {
              node_connection_details.push(unitOpName[unitOpID[i]]);
              // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Waste), ';
            }
          }
        }
      }
      if (unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type'] === 'EDI') {
        if (unit_op_dict[unitOpName[unitOpID[i]]].Feed.length <= 0) {
          node_connection_details.push(unitOpName[unitOpID[i]]);
          // connection_error = connection_error+', '+unitOpName[unitOpID[i]]+'(Feed), ';
        }
        if (unit_op_dict[unitOpName[unitOpID[i]]].Product.length <= 0) {
          node_connection_details.push(unitOpName[unitOpID[i]]);
          // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Product), ';
        }
        if (unit_op_dict[unitOpName[unitOpID[i]]].Electrode_Bleed.length <= 0) {
          node_connection_details.push(unitOpName[unitOpID[i]]);
          // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Waste), ';
        }
        if (unit_op_dict[unitOpName[unitOpID[i]]].Conc_Bleed.length <= 0) {
          node_connection_details.push(unitOpName[unitOpID[i]]);
          // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Waste), ';
        }
      }
      const UnitopNameData = ['CF', 'Mix-Split', 'Pump', 'HP_Pump', 'Stripper', 'Chemical_Dosing'];
      if (UnitopNameData.indexOf(unit_op_dict[unitOpName[unitOpID[i]]]['Unit Type']) >= 0) {
        if (unit_op_dict[unitOpName[unitOpID[i]]].Feed.length <= 0) {
          node_connection_details.push(unitOpName[unitOpID[i]]);
          // connection_error = connection_error+', '+unitOpName[unitOpID[i]]+'(Feed), ';
        }
        if (unit_op_dict[unitOpName[unitOpID[i]]].Product.length <= 0) {
          node_connection_details.push(unitOpName[unitOpID[i]]);
          // connection_error = connection_error+unitOpName[unitOpID[i]]+'(Product), ';
        }
      }
    }
    for (let index = 0; index < node_connection_details.length; index += 1) {
      if (node_connection_details_final.indexOf(node_connection_details[index]) === -1) {
        node_connection_details_final.push(node_connection_details[index]);
      }
    }
    for (let index = 0; index < node_connection_details_final.length; index += 1) {
      if (index !== node_connection_details_final.length - 1) {
        // connection_error = connection_error + node_connection_details_final[index] + ', ';
        connection_error = `${connection_error}${node_connection_details_final[index]}, `;
      } else {
        // connection_error = connection_error + node_connection_details_final[index] + ' ';
        connection_error = `${connection_error}${node_connection_details_final[index]} `;
      }
    }
    if (!findAllConnection) {
      if (connection_error !== '') {
        openModelPopUp(`${connection_error} ${translateObject('connections are incomplete!')}`, 'Warning', 'warning');
        return;
      }
    }
    // ################### End ################
    // Build all directed flow paths from the edge list.
    // - Uses adjacency and indegree to find start nodes (indegree 0)
    // - DFS walks to collect complete paths from each start
    // - Falls back to walking from any node with remaining unvisited edges
    // Returns: Array of paths, where each path is an array of node names in order.
    function buildFlowPaths(edges) {
      if (!Array.isArray(edges) || edges.length === 0) return [];

      // adjacency and indegree maps
      const adj = new Map();
      const indeg = new Map();

      edges.forEach(({ source, target }) => {
        if (!adj.has(source)) adj.set(source, []);
        adj.get(source).push(target);
        indeg.set(target, (indeg.get(target) || 0) + 1);
        if (!indeg.has(source)) indeg.set(source, indeg.get(source) || 0);
      });

      // Start nodes: any node with outgoing edges and indegree 0
      const starts = [...adj.keys()].filter(n => (indeg.get(n) || 0) === 0);
      const visitedEdge = new Set(edges.map(e => `${e.source}->${e.target}`)).clear && new Set();

      const paths = [];

      const walk = (node, path) => {
        const nexts = adj.get(node) || [];
        if (nexts.length === 0) {
          paths.push([...path]);
          return;
        }
        nexts.forEach(nxt => {
          const key = `${node}->${nxt}`;
          if (visitedEdge.has(key)) return;
          visitedEdge.add(key);
          path.push(nxt);
          walk(nxt, path);
          path.pop();
        });
      };

      // walk from starts
      starts.forEach(s => walk(s, [s]));

      // Handle remaining edges (branches/cycles without clear starts):
      // fallback to start from any node whose outgoing edges are not yet fully traversed.
      [...adj.keys()].forEach(s => {
        const remaining = (adj.get(s) || []).some(t => !visitedEdge.has(`${s}->${t}`));
        if (remaining) walk(s, [s]);
      });

      return paths;
    }
    // Derive RO and Feed unit sets relevant to NF checks.
    // - roUnits: names of RO/RO_HP units with NF enabled (via ro_param_dict.is_nf_module)
    // - nfEnabledFeeds: names of Feed units with NF enabled
    // - nfDisabledFeeds: names of Feed units with NF disabled
    function getNFModuleUnits(unitsJson) {
      if (!unitsJson || typeof unitsJson !== 'object') return {
        roUnits: [],
        nfEnabledFeeds: [],
        nfDisabledFeeds: []
      };

      const roUnits = [];
      const nfEnabledFeeds = [];
      const nfDisabledFeeds = [];

      Object.entries(unitsJson).forEach(([name, unit]) => {
        if (!unit) return;

        const type = unit['Unit Type'];

        // RO / RO_HP units considered NF-enabled when ro_param_dict.is_nf_module === true
        if ((type === 'RO' || type === 'RO_HP') &&
          unit.ro_param_dict &&
          unit.ro_param_dict.is_nf_module === true) {
          roUnits.push(name);
        }

        // Feed units: classify by is_nf_module flag
        if (type === 'Feed') {
          const isNF = unit.is_nf_module === true;
          const { name } = unit;
          if (isNF) nfEnabledFeeds.push(name);
          else nfDisabledFeeds.push(name);
        }
      });

      return { roUnits, nfEnabledFeeds, nfDisabledFeeds };
    }
    // Derive lists of unit names used for NF consistency checks:
    // - roUnits: names of RO/RO_HP units that have NF enabled in their ro_param_dict
    // - nfEnabledFeeds: names of Feed units with NF enabled
    // - nfDisabledFeeds: names of Feed units with NF disabled
    const { roUnits, nfEnabledFeeds, nfDisabledFeeds } = getNFModuleUnits(unitop_dict);

    // NF/RO consistency rule:
    // - true if roUnits.length === nfEnabledFeeds.length
    // - true if roUnits.length > 1 and nfEnabledFeeds.length === 1
    // - true if both counts are 0
    // - false otherwise
    // NF/RO consistency decision
    // The rules below determine whether the flowsheet configuration is acceptable:
    // - If there are no RO units, configuration is considered inconsistent (must have RO when NF paths exist)
    // - If there are zero NF-disabled feeds, configuration is inconsistent (at least one NF-disabled feed is expected in this logic branch)
    // - If RO unit count equals NF-enabled feed count, configuration is inconsistent (edge case in current domain rules)
    // - If there is exactly one NF-enabled feed and no NF-disabled feeds while RO units exist, configuration is inconsistent
    // - If there is exactly one NF-enabled feed and at least one NF-disabled feed while one RO unit exists, configuration is inconsistent
    // - If there are RO units and NF-disabled feeds present, configuration is considered consistent
    // - If there are RO units (without the above constraints), configuration is considered consistent
    const nfModuleConsistent = (() => {
      const rounits = roUnits.length;
      const nfEnabledFeed = nfEnabledFeeds.length;
      const nfDisabledFeed = nfDisabledFeeds.length;

      if (rounits === 0) return false;
      if (nfDisabledFeed === 0) return false;
      if (rounits === nfEnabledFeed) return false;
      if (rounits >= 1 && nfEnabledFeed === 1 && nfDisabledFeed === 0) return false;
      if (rounits === 1 && nfEnabledFeed === 1 && nfDisabledFeed > 0) return false;
      if (rounits > 0 && nfDisabledFeed > 0) return true;
      if (rounits > 0) return true;
      return false;
    })();

    if (nfModuleConsistent) {
      // When NF configuration is considered consistent, but NF-disabled feeds are present,
      // build flow paths and validate structural constraints within those paths to guard against
      // subtle misconfigurations (e.g., RO appearing between Feed and NF).
      if (nfDisabledFeeds && nfDisabledFeeds.length > 0) {
        const paths = buildFlowPaths(edges);
        const nfPaths = Array.isArray(paths)
          ? paths.filter(path => Array.isArray(path) && path.some(name => String(name).toLowerCase().startsWith('nf')))
          : [];
        // Identify NF paths that contain an element starting with 'ro' positioned
        // between the first occurrence of a 'feed*' node and a later 'nf*' node.
        // Such ordering is considered invalid in this domain.
        const nfPathsWithROBetweenFeedAndNF = nfPaths.filter(path => {
          if (!Array.isArray(path)) return false;
          const lower = path.map(n => String(n).toLowerCase());
          const feedIdx = lower.findIndex(n => n.startsWith('feed'));
          const nfIdx = lower.findIndex(n => n.startsWith('nf'));
          if (feedIdx === -1 || nfIdx === -1 || nfIdx <= feedIdx) return false;
          // Look for 'ro' element strictly between feedIdx and nfIdx
          return lower.slice(feedIdx + 1, nfIdx).some(n => n.startsWith('ro'));
        });
        // Compute the complement: NF paths that DO NOT have any 'ro*' element
        // placed between the first 'feed*' and later 'nf*'. These paths are structurally valid.
        const nfPathsWithoutROBetweenFeedAndNF = nfPaths.filter(path => {
          if (!Array.isArray(path)) return false;
          const lower = path.map(n => String(n).toLowerCase());
          const feedIdx = lower.findIndex(n => n.startsWith('feed'));
          const nfIdx = lower.findIndex(n => n.startsWith('nf'));
          if (feedIdx === -1 || nfIdx === -1 || nfIdx <= feedIdx) return false;
          return !lower.slice(feedIdx + 1, nfIdx).some(n => n.startsWith('ro'));
        });
        // Extract only Feed unit names from structurally valid NF paths (no RO between Feed and NF).
        // This focuses subsequent validation on the set of feeds actually participating in valid NF paths.
        const feedNamesFromNFPaths = nfPathsWithoutROBetweenFeedAndNF
          .map(path => path.filter(name => {
            const unit = unitop_dict[name];
            const unitType = unit && unit['Unit Type'];
            return unitType === 'Feed' || String(name).toLowerCase().startsWith('feed');
          }))
          .flat();
        const uniqueFeedNamesFromNFPaths = Array.from(new Set(feedNamesFromNFPaths));
        // Extract Feed unit names for the invalid NF paths (RO between Feed and NF) separately.
        // These feeds should NOT have NF enabled per current rules.
        const feedNamesFromROPaths = nfPathsWithROBetweenFeedAndNF
          .map(path => path.filter(name => {
            const unit = unitop_dict[name];
            const unitType = unit && unit['Unit Type'];
            return unitType === 'Feed' || String(name).toLowerCase().startsWith('feed');
          }))
          .flat();
        const uniqueFeedNamesFromROPaths = Array.from(new Set(feedNamesFromROPaths));
        // Validate: all Feed units on valid NF paths must have NF module enabled.
        const feedNFModuleStatuses = uniqueFeedNamesFromNFPaths.map(name => {
          name = name.replace('feed', 'Feed'); // Normalize casing
          const unit = unitop_dict[name];
          const isNFModule = unit && unit.is_nf_module === true;
          return { name, is_nf_module: isNFModule };
        });
        const allFeedsNFEnabled = feedNFModuleStatuses.every(item => item.is_nf_module === true);
        // Validate: all Feed units on invalid RO-between paths must have NF disabled.
        const feedROModuleStatuses = uniqueFeedNamesFromROPaths.map(name => {
          name = name.replace('feed', 'Feed'); // Normalize casing
          const unit = unitop_dict[name];
          const isNFModule = unit && unit.is_nf_module === true;
          return { name, is_nf_module: isNFModule };
        });
        const allFeedsROEnabled = feedROModuleStatuses.every(item => item.is_nf_module === false);
        // Final guardrails and user feedback on invalid configurations
        if (!allFeedsROEnabled) {
          openModelPopUp(translateObject('Invalid configuration: NF module must be disabled only when an RO unit is detected in the relevant Feed–NF path.'), 'Warning', 'warning');
          return;
        }
        if (!allFeedsNFEnabled) {
          openModelPopUp(translateObject('Invalid configuration: Every Feed unitop on the NF path is required to have the NF module enabled.'), 'Warning', 'warning');
          return;
        }
      } else {
        // No NF-disabled feeds present — warn user per domain rule
        openModelPopUp(translateObject('NF module must be enabled in all Feed unitop when NF unitop are present.'), 'Warning', 'warning');
        return;
      }
    };

    delete unitop_dict.null;
    delete unit_op_dict.null;
    fetchLoadings({ loader: true, data: '', msg: '', warningArr: 0, img: '' });
    // fetchLoadings(true, '', '');
    const unit_op_dict_final = { unit_op_dict, unitop_dict };

    const getUserEmail = sessionStorage.getItem('user_email');
    const getUserType = getUserEmail.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
    const params = { file_name: `${getUserEmail}_${filename}.json`, email: getUserEmail, userType: getUserType };
    // let fileExist = false; // checkFileExists(params.file_name, params.email, params.userType);
    async function checkFileExistsFun(fileName, email, userType) {
      try {
        const res = await checkFileExists(fileName, email, userType);
        const { exist } = JSON.parse(res.data);
        return exist;
      } catch (err) {
        console.error('Error checking file existence:', err);
        return false; // Default to file not existing in case of error
      }
    };
    const hasParametricStudy = executeEdiData.parametric_study && executeEdiData.parametric_study.batch_sim;
    const data = {
      new_file: await checkFileExistsFun(params.file_name, params.email, params.userType),
      unit_op_dict_final,
      stream_input_dict_final,
      unit_set_dict,
      project_info_set_dict,
      flow_dict,
      FileName: `${getUserEmail}_${filename}.json`,
      FilePath: `winflows-s3/winflows_file_management/${getUserType}/${getUserEmail}/winfiles/${getUserEmail}_${filename}.json`,
      ...(hasParametricStudy && { batch_sim: executeEdiData.parametric_study.batch_sim })
    };
    console.log(data);
    let key = process.env.REACT_APP_SECRET_KEY; // 'ewfWE@#%$rfdsefg';
    let salt = process.env.REACT_APP_SALT_KEY; // 'ABCDEFGHIJKLMNOP';
    const str = JSON.stringify(data);
    salt = CryptoJS.enc.Utf8.parse(salt);
    key = CryptoJS.enc.Utf8.parse(key);
    const options = {
      iv: salt,
      padding: CryptoJS.pad.NoPadding,
      mode: CryptoJS.mode.CFB,
    };
    const cipher = CryptoJS.AES.encrypt(str, key, options);
    const cipher_new = cipher.ciphertext.toString(CryptoJS.enc.Base64);
    const roUnitOp = [];
    unitOpID.forEach((item) => {
      if (item.includes('ro_') || item.includes('roPump_') || item.includes('nf_') || item.includes('nfPump_')) {
        roUnitOp.push(unitOpName[item]);
      }
    });
    const flow_sheet_dict = findAllPath(data, stream_input_dict, roUnitOp);
    // s3 presigned url
    async function readPresignedS3Url(presignedUrl) {
      try {
        // Fetch the data from the pre-signed URL
        const response = await fetch(presignedUrl);

        // Check if the request was successful
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Determine the content type
        // const contentType = response.headers.get('content-type');

        // let data;

        // Get the content as an ArrayBuffer
        const arrayBuffer = await response.arrayBuffer();

        // Convert ArrayBuffer to string
        const textDecoder = new TextDecoder('utf-8');
        const text = textDecoder.decode(arrayBuffer);

        // Parse the string as JSON
        const data = JSON.parse(text);

        // // Process the data based on content type
        // if (contentType && contentType.includes('application/json')) {
        //   // If it's JSON, parse it
        //   data = await response.json();
        // } else if (contentType && contentType.includes('text')) {
        //   // If it's text, get it as a string
        //   data = await response.text();
        // } else {
        //   // For other types (like binary data), get it as a Blob
        //   data = await response.blob();
        // }

        // Return the data
        return data;

      } catch (error) {
        console.error('Error reading from pre-signed URL:', error);
        throw error;
      }
    }

    // // Usage
    // const presignedUrl = 'https://winflows-s3.s3.amazonaws.com/winflows_file_management/response/2025-01-20%2019%3A15%3A47.json?AWSAccessKeyId=AKIA45PGVNC4HJMTLT7B&Signature=YG5dXOky5qbZ4vgWM3RTs9IgG9c%3D&Expires=1737380872';

    // readPresignedS3Url(presignedUrl)
    //   .then(data => {
    //     // You can now use 'data' as needed in your application
    //   })
    //   .catch(error => {
    //     console.error('Failed to read from S3:', error);
    //   });
    // end here
    if (!findAllConnection) {
      // postWinflowsSolveOrder(data)
      // postWinflowsSolveOrder(cipher_new)
      // axios({
      //   method: 'post',
      //   // url: 'https://b7b624kj2cwfcvm7wvqakrpqmi0sgsrj.lambda-url.us-east-1.on.aws/',
      //   // headers: { 'Content-Type': 'text/plain' },
      //   // url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_solve_order_test',
      //   // url: 'https://76ryoyiantcdplhoqmzwxpc5va0krrng.lambda-url.us-east-1.on.aws/',
      //   url: 'https://dev-winflows.watertechnologies.com/winflows_solve_order', // 'https://dsz23ld3h238t.cloudfront.net/winflows_solve_order',
      //   // url: `https://xkbpehmx1d.execute-api.us-east-1.amazonaws.com/dev/addwinflowfile?param1=${fs.name}.json&param2=${getUserEmail}`,
      //   headers: {},
      //   // data: {
      //   //   // winflows_solve_order_dict,
      //   //   unit_op_dict_final,
      //   //   stream_input_dict_final,
      //   //   unit_set_dict,
      //   //   project_info_set_dict,
      //   //   flow_dict
      //   //   // final_table_dict
      //   // },
      //   // data: cipher_new
      //   data: cipher_new
      // })
      postWinflowsSolveOrder(cipher_new)
        // await axios({
        //   method: 'post',
        //   url: 'https://dev-winflows.watertechnologies.com/winflows_solve_order',
        //   headers: {},
        //   data: cipher_new
        // })
        .then(async (response) => {
          // response.data = await decrypt_data(response.data);
          const preSignedUrl = response.data.url;
          await readPresignedS3Url(response.data.url)
            .then(data => {
              // response.data = decompressedData_with_decrypt(data);
              response.data = decrypt_data(data);
              // console.log('Decrypted response data:', response.data);
              if (custom_all_ROHPLoop.length > 0) {
                setUseRefAfterExecute(true);
              }
              if (custom_all_ROLoop.length > 0) {
                setEnableMixSplitRo(true);
              }
              // You can now use 'data' as needed in your application
            })
            .catch(error => {
              console.error('Failed to read from S3:', error);
            });
          // Delete the preSignedUrl file from S3  abhi
          // const success = await deleteFileFromS3(preSignedUrl);
          // if (success) {
          //   // Handle successful deletion (e.g., update UI, show message)
          // } else {
          //   // Handle deletion failure
          // }

          const url = preSignedUrl.split('.json')[0].split('amazonaws.com/')[1];
          const fNaam = decodeURIComponent(url);
          const psObj = { '0': `${fNaam}.json` };
          await deleteWinAndProjectFile('', '', psObj)
            .then(() => { /* console.warn(data); */ })
            .catch(error => {
              console.error('Failed to read from S3:', error);
            });
          // response.data = await decompressedData_with_decrypt(response.data);
          // response.data = JSON.parse(response.data);
          // setting up flowsheet recovery if presnet else 'NA' by Abhishek on 8-Dec-23
          let resDataFlowsheet_rec = response.data.flowsheet_rec ? response.data.flowsheet_rec : '';
          if (response.data.flowsheet_rec === '' || response.data.flowsheet_rec === 'NA') {
            resDataFlowsheet_rec = '';
          }
          localStorage.setItem('systemRecovery', resDataFlowsheet_rec ? `${(resDataFlowsheet_rec).toFixed(1)} %` : 'NA');
          // localStorage.setItem('systemRecovery', response.data.flowsheet_rec ? `${(response.data.flowsheet_rec).toFixed(1)} %` : 'NA');
          executeOptionFlag = true;
          // added by chandrashekhar  to remove \\\n \\\r " \" + charector in error list for all language
          if (unit_set_dict.language !== 'English') {
            const dataErr_List = Object.keys(response.data.unitop_output);
            dataErr_List.forEach((ele) => {
              const k = { ...response.data.unitop_output[ele].output_user };
              if (Object.keys(k).length && k.err_list && k.err_list.length > 0) {
                k.err_list.map((errlist, iii) => {
                  response.data.unitop_output[ele].output_user.err_list[iii] = cleanMessage(errlist);
                });
              }
            });
          }
          // added by chandrashekhar  to remove \\\n \\\r " \" + charector in error list for all language
          const getErrorData = getErrorHelperData(response.data.unitop_output);
          const flag = checkRoExitsOrNot(response.data.unitop_output);
          if (getErrorData.str === 'no-error') {
            executeObjs(executeNoError(flag));
          } else if ((getErrorData.str === 'errorwarning') || (getErrorData.str === 'warning')) {
            executeObjs(executeError(getErrorData.str, flag));
          }
          if (StandAloneArgo) {
            executeObjs(executeArgoDefault);
          }
          reportErrorListDatas(getErrorData.data);
          localStorage.setItem('streamDataHighlited', 'greater');
          updateControlsButtonTitle();
          let outputData_edi = {};
          for (let i = 0; i < unitOpID.length; i += 1) {
            if (isObjectEmpty(cf_dict) && includes(lowerCase(unitOpID[i]), 'cartridge')) {
              // localStorage.setItem(unitOpName[unitOpID[i]], JSON.stringify(response.data.unitop_output[unitOpName[unitOpID[i]]])) ;
              // if (localStorage.getItem(`${unitOpID[i]}-key`)) {
              //   localStorage.removeItem(`${unitOpID[i]}-key`);
              // }
              // localStorage.setItem(`${unitOpID[i]}-key`, JSON.stringify(response.data.unitop_output[unitOpName[unitOpID[i]]]));
              const outputData_cf = response.data.unitop_output[unitOpName[unitOpID[i]]];
              saveFormDataInLocalStorage({ record: outputData_cf, type: 'cf-output', id: unitOpID[i], item: 'cf-output-dict' });
            }
            if (isObjectEmpty(dosing_dict) && includes(lowerCase(unitOpID[i]), 'chemicaldosing')) {
              const outputData_cd = response.data.unitop_output[unitOpName[unitOpID[i]]];
              saveFormDataInLocalStorage({ record: outputData_cd, type: 'Chemical_Dosing', id: unitOpID[i], item: 'cd-output-dict' });
            }
            if (isObjectEmpty(edi_dict) && includes(lowerCase(unitOpID[i]), 'edi')) {
              outputData_edi = response.data.unitop_output[unitOpName[unitOpID[i]]];
              saveFormDataInLocalStorage({ record: outputData_edi, type: 'EDI', id: unitOpID[i], item: 'edi-output-dict' });
            }
            // // saving the response data into localhost
            // if (isObjectEmpty(turbo_exc) && includes(lowerCase(unitOpID[i]), 'tc')) {
            //   const outputData_tc = response.data.unitop_output[unitOpName[unitOpID[i]]];
            //   saveFormDataInLocalStorage({ record: outputData_tc, type: 'TRD_data', id: unitOpID[i], item: 'turbo_charger-dict' });
            // }
          }
          if (localStorage.getItem('stream_ouput_data')) {
            localStorage.removeItem('stream_ouput_data');
            localStorage.removeItem('ro_ouput_data');
            localStorage.removeItem('unit_set_dict');
          }
          const getAllKey = Object.keys(response?.data?.unitop_output || {});
          localStorage.setItem('stream_input_dict', JSON.stringify(stream_input_dict));
          localStorage.setItem('stream_ouput_data', JSON.stringify(response.data?.stream_output?.stream_output_usr || {}));
          localStorage.setItem('ro_ouput_data', getAllKey.length ? JSON.stringify(response?.data?.unitop_output || {}) : '');
          localStorage.setItem('unit_set_dict', JSON.stringify(response?.data?.unit_set_dict || {}));
          // get the previous unit_set_dict from win file (while opening any win file).
          localStorage.setItem('previous_units', JSON.stringify(response?.data?.unit_set_dict || {}));
          dispatch(setStream_ouput_data(response?.data?.stream_output?.stream_output_usr));

          if (getAllKey.length === 0) {
            disabledStripperAndExplorerTab();
            executeOptionFlag = false;
          }
          const aggregated_stream_data = [];
          Object.values(unit_op_dict_final.unitop_dict).forEach((objKey) => {
            if (objKey['Unit Type'] === 'EDI') {
              EDIFormData[objKey.name] = { unit_op_dict_final: { unitop_dict: { [objKey.name]: { ...unit_op_dict_final.unitop_dict[objKey.name] } } } };
            } else if (['RO_HP', 'RO', 'RO_ERD', 'RO_PW', 'RO_TC', 'ROHP_FeedBleed', 'RO_FeedBleed'].indexOf(objKey['Unit Type']) >= 0) {
              if (objKey.Product.length > 0 || objKey.Split_flow.length > 0) {
                aggregated_stream_data.push({
                  name: objKey.name,
                  ...(objKey.Product[0] && { product: objKey.Product[0] }),
                  ...(objKey.Split_flow[0] && { split_flow: objKey.Split_flow[0] })
                });
              }
            }
          });
          Object.keys(EDIConnection).forEach((keys) => {
            EDIFormData[EDIConnection[keys]].stream_data = response.data.stream_output.stream_output_std[keys];
            EDIFormData[EDIConnection[keys]].unit_set_dict = response.data.unit_set_dict;
            EDIFormData[EDIConnection[keys]].is_single_unit_op = true;
          });
          executeEdiData.data = EDIFormData;
          const reportData = {};
          executeEdiData.reportData = {};
          const options = JSON.parse(localStorage.getItem('options'));
          const abFactor = Number(get(options, 'abFactor', '0'));
          const version = JSON.parse(localStorage.getItem('db_version')) || {};
          version.project_name = project_info_set_dict.project_name;
          version.file_name = filename;
          version.last_update = modifiedDate || '2023-10-13';
          version.cloud_version = '5.0';
          if (ro_dict) {
            Object.keys(ro_dict).map((ele) => {
              const data = ro_dict[ele];
              delete ro_dict[ele];
              ro_dict[localStorage.getItem(ele)] = data;
              return ro_dict;
            });
          }
          if (clro_dict) {
            Object.keys(clro_dict).map((ele) => {
              const data = clro_dict[ele];
              delete clro_dict[ele];
              clro_dict[localStorage.getItem(ele)] = data;
              return clro_dict;
            });
          }
          ro_dict = { ...clro_dict, ...ro_dict };
          let hasValidUnitType = false;

          Object.keys(ro_dict).forEach((rodict) => {
            if (!['null', null, undefined, ''].includes(rodict)) {
              const unitType = response?.data?.unitop_output?.[rodict]?.unit_type;

              if (unitType !== undefined) {
                ro_dict[rodict].unit_type = unitType;
                hasValidUnitType = true;
              }
            }
          });

          if (!hasValidUnitType) {
            console.warn('RO unit_type mapping not found in unitop_output. Continuing execution with available response data.');
          }
          const sortValROUnitop = sortingRoData();
          if (sortValROUnitop.sortingVal.length > 0) {
            if (response.data && response.data.report_dict && response.data.report_dict.ro_summary && response.data.report_dict.ro_summary.ro_system_dict) {
              response.data.report_dict.ro_summary.ro_system_dict['RO Unit ID'] = sortValROUnitop.sortingVal;
              response.data.report_dict.ro_elem_summary['RO Unit ID'] = sortValROUnitop.sortingVal;
            }
          }
          // for Detailed RO Element-Level Data we are update the ro_ele_summary['RO Unit ID'] value chandrashekhar START
          if (response.data.report_dict.ro_elem_summary && response.data.report_dict.ro_elem_summary['RO Unit ID']) {
            const RO_Unit_ID = [];
            const ro_ele_summary = response.data.report_dict.ro_elem_summary;
            ro_ele_summary['RO Unit ID'].map((ele) => {
              Object.keys(ro_ele_summary).map((ObjEle) => {
                if (ObjEle.indexOf(ele) >= 0) {
                  RO_Unit_ID.push(ObjEle);
                }
              });
            });
            response.data.report_dict.ro_elem_summary['RO Unit ID'] = RO_Unit_ID;
          }
          // for Detailed RO Element-Level Data we are update the ro_ele_summary['RO Unit ID'] value chandrashekhar END
          if (response.data && response.data.report_dict) {
            reportData.report_dict = response.data.report_dict;
            reportData.report_dict.system_units = response?.data?.unit_set_dict;
            reportData.report_dict.stream_output = response?.data?.stream_output?.stream_output_usr;
            reportData.report_dict.errors = getErrorData?.data;
            reportData.report_dict.stream_input_dict = stream_input_dict;
            reportData.report_dict.edi_output_dict = outputData_edi;
            reportData.report_dict.project_details = version;
            reportData.report_dict.ro_hp = { ro_dict, abFactor };
            reportData.report_dict.ediOutputData = ediOutputData;
            reportData.report_dict.schemanticView = !flag;
          }
          if (response.data && response.data.report_dict &&
            reportData.report_dict.ro_summary && // Check if ro_summary exists and is not null/undefined
            Object.keys(reportData.report_dict.ro_summary).length > 0 // Check if ro_summary is not an empty object {}
          ) {
            // Assign aggregated_stream_data to ro_summary only if ro_summary is a valid non-empty object.
            reportData.report_dict.ro_summary.aggregated_stream_data = aggregated_stream_data;
          }
          if (reportData.report_dict.stream_output) {
            const filterObj = {};
            const { stream_output } = reportData.report_dict;
            for (const key in stream_output) {
              const item = stream_output[key];
              if (item.label) {
                filterObj[key] = item;
              }
            }
            reportData.report_dict.stream_output = filterObj;
          }
          executeEdiData.reportData = reportData;
          executeEdiData.flowSheetSolvdData = response.data;
          console.log(response.data);
          setInputOutputFlag(true);
          fetchLoadings({ loader: false, data: '', msg: 'success', warningArr: getErrorData, img: '' });
          ediOutputDataset(ediOutputData);
          const downloadBtn = document.querySelector('.download-btn.flowsheet');
          if (downloadBtn) {
            downloadBtn.click();
          }
        }).catch((error) => {
          executeOptionFlag = true;
          openModelPopUp(translateObject('Flowsheet solving has failed.'), 'Error', 'error');
          fetchLoadings({ loader: false, data: '', msg: '', warningArr: 0, img: '' });
          ediOutputDataset([]);
        });
    } else {
      fetchLoadings({ loader: false, data: flow_sheet_dict ? flow_sheet_dict.Type : '', msg: '', warningArr: 0, img: '' });
      ediOutputDataset([]);
      // fetchLoadings(false, flow_sheet_dict ? flow_sheet_dict.Type : '', '');
    }
    // };
  };
  useEffect(() => {
    if (executeFlag) {
      setExecuteFlag(false);
      onExecute();
    }
  }, [dispatch]);

  return (
    <>
      <div style={{ display: 'none' }} />
      {duplicateNodeFlag && (<div style={{ display: 'none' }} />)}
    </>
  );
};
export default ExecutePopup;